var NOM_MODULE = 'gestion-roles';

var POSITION_SCROLLBAR = 0;

var tree_data = {
    'validations': {name: 'Validations', type: 'folder'}
};

tree_data['validations']['additionalParameters'] = {
    'children': {
        'erreurs': {name: 'Erreurs (0)', type: 'folder', 'icon-class': 'red'},
        'avertissements': {name: 'Avertissements (0)', type: 'folder', 'icon-class': 'orange'},
    }
};
tree_data['validations']['additionalParameters']['children']['erreurs']['additionalParameters'] = {'children': {}};
tree_data['validations']['additionalParameters']['children']['avertissements']['additionalParameters'] = {
    'children': {}
};

/**
 * Detects if the application is running within an Ionic app
 * @returns {boolean} True if running in Ionic app, false otherwise
 */
function isRunningInIonicApp() {
    // Method 1: Check for Capacitor (modern Ionic apps)
    if (window.Capacitor) {
        console.log('Detected Ionic app via Capacitor');
        return true;
    }

    // Method 2: Check for Cordova (older Ionic apps)
    if (window.cordova || window.phonegap) {
        console.log('Detected Ionic app via Cordova/PhoneGap');
        return true;
    }

    // Method 3: Check for Ionic DOM elements
    if (document.querySelector('ion-app') || document.querySelector('ion-content')) {
        console.log('Detected Ionic app via DOM elements');
        return true;
    }

    console.log('Not running in Ionic app');
    return false;
}

var DataSourceTree = function (options) {
    this._data = options.data;
    this._delay = options.delay;
};

DataSourceTree.prototype.data = function (options, callback) {
    var $data = null;

    if (!("name" in options) && !("type" in options)) {
        $data = this._data;//the root tree
        callback({data: $data});
        return;
    }
    else if ("type" in options && options.type == "folder") {
        if ("additionalParameters" in options && "children" in options.additionalParameters)
            $data = options.additionalParameters.children;
        else $data = {};
    }

    if ($data != null)
        callback({data: $data});
};

$(function () {
    // Set a flag to indicate if we're running in the Ionic app
    window.isRunningInApp = isRunningInIonicApp()
    console.log("isRunningInApp", window.isRunningInApp);

    console.log('jQuery ready function executing...');
    initEditeurFiche();
    if (window.isRunningInApp) {
        console.log('In mode déconnecté, fixing qualite-complexite containers...');
        // Add a small delay to ensure DOM is fully ready
        // setTimeout(fixQualiteComplexiteContainers, 100);

        $('#container').css('padding-bottom', `${$('ion-tab-bar').outerHeight()}px`);
    }

    if (!window.isRunningInApp) {
        window.onbeforeunload = function () {
            if ($('.valeur-modifiee').length > 0) {
                // Put your custom message here
                return "";
            }
        };
    }

    $(document).find('#form_recherche_ue #id_bool_construction_neuve').on('change', function() {
        $('#form_recherche_ue').submit();
    });

    $(document).off('submit', '#form_recherche_ue').on('submit', '#form_recherche_ue', function(e) {
        e.preventDefault();
        var form = $(e.target);
        $.ajax({
            type: form.attr('method'),
            url: form.attr('action'),
            data: form.serialize(),
            success: function (response) {
                $('#resultat_recherche').html(response);
                $('#resultat_recherche').find('.cboxElement').colorbox();
            }
        });
    });
    if (window.isRunningInApp) {
        window.onoffline = function () {
            afficherAvertissementEditeurFiche('avertissement_mode_deconnecte', 'avertissement_mode_deconnecte_texte',
                "Vous êtes en  mode déconnecté. Aucun accès à Internet.");
            activerDesactiverModeHorsLigneTableauBlancSignature();
        };
        window.ononline = function () {
            fermerAvertissementEditeurFiche('avertissement_mode_deconnecte');
            activerDesactiverModeHorsLigneTableauBlancSignature();
        };
    }

    $('.lien-editer-fiche').on('click', function () {
        $('')
        editerFicheEvenementCourant();
    });

});

$(window).resize(function () {
    calculerHauteurAncre();
    ordonnerBlocs();
    fluidDialog();
});

function activerDesactiverModeHorsLigneTableauBlancSignature() {
    var btnSignatureB79Remplis = $(".btn-signature-rempli");
    btnSignatureB79Remplis.attr("disabled", !navigator.onLine); // désactive la consultation des signatures créées
    if(navigator.onLine) {
        btnSignatureB79Remplis.tooltip('destroy');
    } else {
        btnSignatureB79Remplis.tooltip({title:"Signature existante inaccessible en mode déconnecté"});
    }

    if($("#modal_signature_b79").length) {
        $("#modal_signature_b79 .badge-tb-deconnecte").toggleClass("hidden", navigator.onLine);
    }

    if($("#modal_tableau_blanc").length) {
        $("#modal_tableau_blanc .badge-tb-deconnecte").toggleClass("hidden", navigator.onLine);
        $("#modal_tableau_blanc .tb-pagination").toggleClass("hidden", !navigator.onLine);
        $("#modal_tableau_blanc .tb-btn-croquis").toggleClass("hidden", !navigator.onLine);
        $("#modal_tableau_blanc .sidebar-croquis").toggleClass("hidden", !navigator.onLine);
        /* ferme le menu de choix de croquis s'il est ouvert et qu'on passe en mode hors ligne */
        if(!$("#btn_open_croquis_sidebar").hasClass("collapsed") && !navigator.onLine) {
            $('#btn_open_croquis_sidebar').trigger('click');
        }
    }
}

// catch dialog if opened within a viewport smaller than the dialog width
$(document).on("dialogopen", ".ui-dialog", function (event, ui) {
    fluidDialog();
});

function ordonnerBlocs(onResize) {
    onResize = typeof onResize !== 'undefined' ? onResize : true;

    var largeur = $(window).width();
    var largeurDefinie = 1878; // équivalent à @media (max-width: 1900px)
    var largeurBlocContainer = $('#blocs-container').attr('largeur');
    if (!onResize) {
        // si on n'est pas dans le resize, la valeur ne doit pas exister pour forcer l'ordre des blocs à l'initialisation de la fiche
        // quand on arrive de l'explorateur ue, la valeur est toujours là mais ça ne devrait pas, alors, on force la valeur à 'undefined'
        largeurBlocContainer = undefined;
    }

    var containerRows = $('#blocs-container .blocs-container-row');

    containerRows.each(function () {
        var containerRow = $(this);
        var containerColonne = containerRow.children('.blocs-container-col');
        var blocs = containerColonne.find('form.blocForm');

        if (largeur != largeurBlocContainer) {

            if (largeur > largeurDefinie) {
                // ordonner par colonne et par no de bloc ascendant
                if (largeurBlocContainer == undefined || largeurBlocContainer <= largeurDefinie) {

                    var blocsColonneA = blocs.filter('[colonne=1]').detach();
                    var blocsColonneB = blocs.filter('[colonne=2]').detach();
                    sortObjects(blocsColonneA, 'id_bloc');
                    sortObjects(blocsColonneB, 'id_bloc');
                    $(containerColonne).first().append(blocsColonneA);
                    $(containerColonne).last().append(blocsColonneB);
                }
            }
            else {
                // ordonner par no de bloc ascendant
                if (largeurBlocContainer == undefined || largeurBlocContainer > largeurDefinie) {

                    blocs = blocs.detach();
                    sortObjects(blocs, 'id_bloc');
                    $(containerColonne).first().append(blocs);
                }
            }
        }

    });

    $('#blocs-container').attr('largeur', $(window).width());
}


function activer_desactiver_liens_methodes_calcul() {
    var affichage_fiche = {
        'fiche-terrain-general': ['cout-terrain'],
        'fiche-terrain-agricole': ['cout-terrain'],
        'fiche-admin': ['cout-terrain'],
        'fiche-residentiel': ['cout-terrain', 'cout-classe', 'cout-age-apparent', 'cout-sommaire-evimbec', 'cout-simplifie'],
        'fiche-non-residentiel': ['cout-terrain', 'cout-classe', 'cout-age-apparent', 'cout-sommaire-evimbec', 'cout-simplifie'],
        'fiche-multi': ['cout-terrain', 'cout-classe', 'cout-age-apparent', 'cout-sommaire-evimbec', 'cout-simplifie'],
        'fiche-agricole': ['cout-terrain', 'cout-sommaire-evimbec', 'cout-simplifie']
    }; //TODO: Mettre dans la BD après les tests de gestion des options d'affichage pour la sélection des méthodes de calcul.cout-sommaire-evimbec
    var typeFiche = $('#container').attr('class');
    var selecteur = $('#methode-cout').find('li');
    var classe = 'methode-calcul-lien-disabled';
    $.each(selecteur, function (i) {
        if ($.inArray($(selecteur[i]).attr('data-type'), affichage_fiche[typeFiche]) === -1) {
            $(selecteur[i]).addClass(classe); // On ajoute la classe disabled sur l'option de la liste
        } else {
            $(selecteur[i]).removeClass(classe); // On retire la classe disabled sur l'option de la liste
        }
    });
}


function sortObjects(object, attribut, ascending) {
    ascending = typeof ascending !== 'undefined' ? ascending : true;

    object.sort(function (a, b) {

        var contentA = $(a).attr(attribut);
        var contentB = $(b).attr(attribut);
        if (ascending) {
            return (contentA < contentB) ? -1 : (contentA > contentB) ? 1 : 0;
        }
        else {
            return (contentA > contentB) ? -1 : (contentA < contentB) ? 1 : 0;
        }
    });
}

function initEditeurFiche() {
    console.log("In initEditeurFiche... ");

    masquesSelection.init();
    var dateEvenement = $('#date-evenement').val();
    var idEvenement = $('#id-evenement').val();

    $(document.body).on('click', '.batiment', function () {

        var idBatiment = $(this).attr('id-batiment');
        var idTypeBatiment = $(this).attr('id-type-batiment');
        var noBatiment = $(this).attr('no-batiment'); //obtiens le numéro de batiment attribué automatiquement
        var idFormulaire = $(this).attr('id-formulaire');
        var titreFiche = getTitre(idFormulaire);
        var descriptif = $(this).attr('descriptif');
        initOuvrirFiche(idBatiment, idTypeBatiment, titreFiche, idEvenement, dateEvenement, idFormulaire);

        $('#current-id-formulaire').val(idFormulaire);
        $('#current-id-batiment').val(idBatiment);
        $('#current-no-batiment').val(noBatiment); //stock la no batiment de la fiche de batiment sélectionnés
        $('#current-id-type-batiment').val(idTypeBatiment);
        $('#current-descriptif').val(descriptif);

    });

    $('.terrain-general').on('click', function () {

        var idUe = $(this).attr('id-ue');
        var titreFiche = getTitre(4);
        var idTypeBatiment = null;
        initOuvrirFiche(idUe, idTypeBatiment, titreFiche, idEvenement, dateEvenement, ID_FORMULAIRE.terrainGeneral);

        $('#current-id-formulaire').val(ID_FORMULAIRE.terrainGeneral);
        $('#current-id-batiment').val(idUe);
        //    On retire les liens sur tout sauf sur la Valeur terrain

    });

    $('.terrain-agricole-boise').on('click', function () {

        var idUe = $(this).attr('id-ue');
        var titreFiche = getTitre(5);
        var idTypeBatiment = null;
        initOuvrirFiche(idUe, idTypeBatiment, titreFiche, idEvenement, dateEvenement, ID_FORMULAIRE.terrainAgricoleBoise);

        $('#current-id-formulaire').val(ID_FORMULAIRE.terrainAgricoleBoise);
        $('#current-id-batiment').val(idUe);

    });


    $('#select-type-batiment').on('change', function () {
        if ($(this).val() != '') {
            $('#m-type-batiment').removeClass('disabled');
        } else {
            $('#m-type-batiment').addClass('disabled');
        }
    });


    $('.renseignement-administratif').on('click', function () {
        fiche_bouton_clicked($(this), ID_FORMULAIRE.renseignementAdministratif);
    });


    $('.resultat-evaluation').on('click', function () {
        fiche_bouton_clicked($(this), ID_FORMULAIRE.resultatEvaluation);
    });


    function fiche_bouton_clicked(control, id_formulaire) {
        var idUe = control.attr('id-ue');
        var titreFiche = getTitre(id_formulaire);
        var idTypeBatiment = null;
        initOuvrirFiche(idUe, idTypeBatiment, titreFiche, idEvenement, dateEvenement, id_formulaire);

        $('#current-id-formulaire').val(id_formulaire);
        $('#current-id-batiment').val(idUe);
    }

    initAceThumbnails('colorboxInformation');
    $('[data-rel=tooltip]').tooltip();
    $('[data-rel=popover]').popover({html: true});


    // Bouton d'un nouveau bâtiment dans le sélecteur de fiches
    $("#m-type-batiment").click(function () {


        var idTypeBatiment = $('#select-type-batiment').val();
        var idTypeBatimentText = $('#select-type-batiment option:selected').text();
        var idFormulaire = $('#select-type-batiment option:selected').attr('id-formulaire');

        var iconFiche = getIcon(idTypeBatiment);
        var dateEvenement = $('#date-evenement').val();
        var idEvenement = $('#id-evenement').val();
        var idUe = $('#id-ue').val();

        var idBatiment;

        // on obtient le numéro séquentiel suivant du bâtiment
        $.ajax({
            type: "POST",
            url: '/gestion-roles/editeur-fiche/get-numero-next-batiment/' + idUe + '/' + idTypeBatiment + '/',
            dataType: 'json',
            success: function (response) {
                $('ul.ef-batiment-list').append('<li id="spin-nouveau-batiment"><div id="spin-nouveau-batiment-div"><img class="photo_arrondie" src="' + url_non_disponible_mini + '" style="height: 125px;width: 125px" data-dismiss="modal"><div></li>');
                wait.start('spin-nouveau-batiment-div');
                var noBatiment = response.no_batiment;
                var listeBatimentsAffiches = $('#modalChoisirFiche .batiment');
                var maxNoBatiment = noBatiment;
                var boolAjouterUnDePlus = false;

                // On vient s'assurer d'incrémenter manuellement le next no_batiment reçu du serveur si jamais l'utilisateur vient d'ajouter plusieurs bâtiments sans avoir été sauvegarder le b08 dans la fiche.
                $.each(listeBatimentsAffiches, function (i, batiment) {

                    var currentNoBatiment = $(batiment).attr('no-batiment');
                    if (currentNoBatiment >= maxNoBatiment) {
                        maxNoBatiment = currentNoBatiment;
                        boolAjouterUnDePlus = true;
                    }
                });

                if (boolAjouterUnDePlus) {
                    var str = "" + (parseInt(maxNoBatiment) + 1);
                    var pad = "000";
                    maxNoBatiment = pad.substring(0, pad.length - str.length) + str;
                }


                var boolConstructionNeuve = false;
                if ($('#construction-neuve').is(':checked')) {
                    boolConstructionNeuve = true;
                }
                var params;
                if (boolConstructionNeuve) {

                    params = {
                        'id_ue': idUe,
                        'typeBatiment': idTypeBatiment,
                        'evenement': idEvenement,
                        'date_debut': dateEvenement,
                        'natureEvenement': 4, // Construction neuve
                        'superficie_projetee': 0,
                        'bool_demande_originale': 0
                    };

                    // Dans le cas d'une construction neuve, nous réutilisons le l'url du DRF créé pour l'ajout à l'étape 3 du permis. Cela insert, dans toutes les tables nécessaires depuis eval.batiment
                    $.ajax({
                        type: 'POST',
                        url: '/gestion-roles/construction-neuve-x-evenement-creation/',
                        data: params,
                        dataType: 'json',
                        success: function (response) {
                            idBatiment = response.id_batiment;
                            afficherPastilleNouveauBatiment(idBatiment, idFormulaire, idTypeBatiment, maxNoBatiment, idTypeBatimentText, iconFiche);
                        }
                    });

                } else {
                    // On insert le bâtiment
                    params = {
                        'typeBatiment': idTypeBatiment
                    };
                    $.ajax({
                        type: 'POST',
                        url: '/gestion-roles/batiments/',
                        data: params,
                        dataType: 'json',
                        success: function (response) {

                            idBatiment = response.id_batiment;

                            //insert batimentxue
                            var params = {
                                "uniteEvaluation": idUe,
                                "batiment": idBatiment,
                                "date_debut": dateEvenement
                            };

                            $.ajax({
                                type: 'POST',
                                url: '/gestion-roles/batiments-x-unite-evaluation/',
                                data: params,
                                dataType: 'json',
                                success: function (response) {
                                    afficherPastilleNouveauBatiment(idBatiment, idFormulaire, idTypeBatiment, maxNoBatiment, idTypeBatimentText, iconFiche);

                                }
                            });
                        }
                    });

                }
            },
        }).fail(function (jqxhr, textStatus, errorThrown) {
            infos.ajouterMessageToast({
                message: jqxhr.responseText,
                messageDuree: 5000,
                messageCouleur: "red"
            });
        });
    });

    // Si le paramètre du type de fiche est reçu en paramètre. on bypass l'affichage de la fenêtre modale de sélection et allons directement à la fiche

    var currentIdBatiment = $('#current-id-batiment').val();
    var currentIdTypeBatiment = $('#current-id-type-batiment').val();
    var currentIdFormulaire = $('#current-id-formulaire').val();
    var idUe = $('#id-ue').val();


    if (currentIdFormulaire != 'None' && currentIdFormulaire != undefined) {

        var titreFiche = getTitre(currentIdFormulaire);
        console.log("Before initOuvrirFiche: currentIdBatiment: " + currentIdBatiment + ", currentIdTypeBatiment: " + currentIdTypeBatiment + ", titreFiche: " + titreFiche + ", idEvenement: " + idEvenement + ", dateEvenement: " + dateEvenement + ", currentIdFormulaire: " + currentIdFormulaire);
        initOuvrirFiche(currentIdBatiment, currentIdTypeBatiment, titreFiche, idEvenement, dateEvenement,
            currentIdFormulaire);
        var currentNoBatiment = $('#current-no-batiment').val();
        var currentCourtDescriptif = $('#current-descriptif').val();

        $('#current-no-batiment').val(currentNoBatiment);
        $('#current-descriptif').val(currentCourtDescriptif);

    }
    else {
        // On ouvre la fenêtre modale de sélection de fiche
        if ($('#modal-table-batiment').length) {
            fenetreModal.redimentionnerModal('modalChoisirFiche', 'grande', 'immense');
            modalTableauBatiment(idUe, idEvenement);
        }
        $('#modalChoisirFiche').modal('show');
    }
    if (!window.editeurFicheBoutonsInitialized) {
        initBoutonsEditeurFiche();
    }
}

function estModeDeconnecte() {
    if (!navigator.onLine) {
        infos.ajouterMessageToast({
            message: "Vous êtes présentement en mode déconnecté. Veuillez réessayer plus tard quand vous serez de " +
                "retour au mode connecté.",
            messageDuree: 5000,
            icone: 'fa-exclamation-triangle',
            iconeCouleur: 'orange'
        });
        return true;
    }
    return false;
}

function generateHtmlForSaveModeDeconnecte() {
    console.log('🔥 FUNCTION CALLED - generateHtmlForSaveModeDeconnecte');
    try {
        console.log('=== GENERATING HTML FOR SAVE ===');

        // Step 1: Reset positions
        const enteteFixe = document.getElementById('entete-fixe');
        const liensBlocs = document.getElementById('liens-blocs');

        const originalPositions = {
            enteteTop: enteteFixe?.style.top || '',
            liensTop: liensBlocs?.style.top || ''
        };

        if (enteteFixe) {
            enteteFixe.style.top = '0px';
        }
        if (liensBlocs) {
            liensBlocs.style.top = '181px';
        }

        // Step 1.5: SYNCHRONISATION DYNAMIQUE
        synchronizeAllFormElements();

        // Step 2: Extract content that we want to keep
        const rootFiche = document.getElementById('root-fiche');
        const contentToKeep = rootFiche ? rootFiche.innerHTML : '';

        const headContent = document.head.innerHTML;

        // Step 3: Restore positions
        if (enteteFixe && originalPositions.enteteTop) {
            enteteFixe.style.top = originalPositions.enteteTop;
        }
        if (liensBlocs && originalPositions.liensTop) {
            liensBlocs.style.top = originalPositions.liensTop;
        }

        // Step 4: Generate clean HTML with base template
        return `<!DOCTYPE html>
                <html lang="fr">
                    <head>
                        ${headContent}
                    </head>
                    <body>
                        ${contentToKeep}
                    </body>
                </html>`;

    } catch (error) {
        console.error('❌ Error generating HTML for save:', error);
        return `<html><body><h1>Error: ${error.message}</h1></body></html>`;
    }
}

function synchronizeAllFormElements() {
    console.log('🔄 Starting dynamic form synchronization...');

    const allFormElements = document.querySelectorAll(
        'input, select, textarea, [contenteditable="true"]'
    );

    let syncCount = 0;
    const syncResults = {
        inputs: 0,
        selects: 0,
        textareas: 0,
        contentEditable: 0,
        errors: []
    };

    allFormElements.forEach((element, index) => {
        try {
            const elementInfo = getElementInfo(element);
            const synced = syncElementValue(element);

            if (synced) {
                syncCount++;
                syncResults[elementInfo.type]++;

                if (element.classList.contains('valeur-modifiee') || element.value) {
                    console.log(`✅ [${index}] ${elementInfo.type}: ${elementInfo.identifier} = "${elementInfo.value}"`);
                }
            }
        } catch (error) {
            syncResults.errors.push({
                element: getElementInfo(element),
                error: error.message
            });
            console.warn(`⚠️ Error syncing element:`, error);
        }
    });

    console.log('📊 Synchronization Summary:', {
        totalElements: allFormElements.length,
        synchronized: syncCount,
        details: syncResults
    });

    if (syncResults.errors.length > 0) {
        console.warn('⚠️ Synchronization errors:', syncResults.errors);
    }

    console.log('✅ Dynamic form synchronization completed');
}

function getElementInfo(element) {
    return {
        type: getElementType(element),
        tag: element.tagName.toLowerCase(),
        identifier: element.name || element.id || element.className || `${element.tagName}[${Array.from(element.parentNode.children).indexOf(element)}]`,
        value: getElementValue(element),
        hasModifiedClass: element.classList.contains('valeur-modifiee')
    };
}

function getElementType(element) {
    if (element.tagName === 'INPUT') return 'inputs';
    if (element.tagName === 'SELECT') return 'selects';
    if (element.tagName === 'TEXTAREA') return 'textareas';
    if (element.hasAttribute('contenteditable')) return 'contentEditable';
    return 'unknown';
}

function getElementValue(element) {
    if (element.hasAttribute('contenteditable')) {
        return element.innerHTML || element.textContent;
    }
    if (element.type === 'checkbox' || element.type === 'radio') {
        return element.checked;
    }
    return element.value || '';
}

function syncElementValue(element) {
    const tagName = element.tagName.toLowerCase();

    switch (tagName) {
        case 'input':
            return syncInputElement(element);

        case 'select':
            return syncSelectElement(element);

        case 'textarea':
            return syncTextareaElement(element);

        default:
            if (element.hasAttribute('contenteditable')) {
                return syncContentEditableElement(element);
            }
            return false;
    }
}

function syncInputElement(input) {
    const inputType = input.type.toLowerCase();

    switch (inputType) {
        case 'checkbox':
        case 'radio':
            if (input.checked) {
                input.setAttribute('checked', 'checked');
            } else {
                input.removeAttribute('checked');
            }
            return true;

        case 'file':
            // Les inputs file ne peuvent pas être synchronisés pour des raisons de sécurité
            return false;

        default:
            // text, number, email, tel, url, password, date, etc.
            const value = input.value || '';
            input.setAttribute('value', value);
            return true;
    }
}

function syncSelectElement(select) {
    let hasSelection = false;

    Array.from(select.options).forEach(option => {
        if (option.selected) {
            option.setAttribute('selected', 'selected');
            hasSelection = true;
        } else {
            option.removeAttribute('selected');
        }
    });

    return true;
}

function syncTextareaElement(textarea) {
    // Pour les textareas, la valeur est stockée dans le contenu textuel
    textarea.textContent = textarea.value || '';
    return true;
}

function syncContentEditableElement(element) {
    // Les éléments contenteditable gardent déjà leur contenu dans le DOM
    // Mais on peut nettoyer ou standardiser si nécessaire
    return true;
}

function initBoutonsEditeurFiche() {
    console.log('=== initBoutonsEditeurFiche CALLED ===');

    $('#btnSaveEditeurFiche').off('click');

    $('#btnSaveEditeurFiche').on('click', function () {
        if (window.isRunningInApp) {
            window.dispatchEvent(new CustomEvent('fiche-save-requested', {
                detail: {
                    htmlContent: generateHtmlForSaveModeDeconnecte()
                }
            }));
        } else if (estModeDeconnecte()) return;
        else {
            saveBlocs(false);
        }
    });

    $('#ef-btn-document').off('click').on('click', function () {
        if (estModeDeconnecte()) return;
        var url = $(this).attr('document');
        window.open(url, '_blank');
    });

    // On utilise le bouton Ouvrir/Fermer blocs comme un bouton bascule
    $('#btnOuvrirFermerBlocs').on('click', function () {
        toggleOuvrirFermerBlocs($(this));
    });

    $('#btnChoisirFiche').on('click', function () {
        if (estModeDeconnecte()) return;

        if ($('#modal-table-batiment').length) {

            if (!$('#modal-table-batiment tbody tr').length) {
                var idUe = $('#id-ue').val();
                var idEvenement = $('#id-evenement').val();

                fenetreModal.redimentionnerModal('modalChoisirFiche', 'grande', 'immense');
                modalTableauBatiment(idUe, idEvenement);
            }

        }
        // On peut changer les numéros des bâtiments pour des 003, etc, mais on doit aussi recharger le sélecteur de fiche parce qu'un numéro de bâtiment changé doit par la suite apparaître dans le sélecteur.
        if (document.getElementById('modalChoisirFiche') !== null) {
            $('#modalChoisirFiche').modal('show');
        }
    });

    $('#btnB81Service').on('click', function () {
        $('#modalB81').modal('show');
    });

    $('#btn-imprimer-fiche').on('click', function () {
        if (estModeDeconnecte()) return;
        $('#print-id-evenement').val($('#id-evenement').val());
        $('#id-formulaire-fiche').val($('#current-id-formulaire').val());
        $("#frm-export-pdf-lot").submit();
    });

    $('#btn_print_b05_photos').off('click').on('click', function () {
        if (estModeDeconnecte()) return;

        $('#print_b05_id_bat').val($('#current-id-batiment').val());
        $('#frm_print_b05_photos').submit();
    });

    $('#ef-date-evenement').on('click', 'li', function () {
        if (estModeDeconnecte()) return;
        var idEvenement = $(this).attr('data-id-evenement');
        ouvrirUrlEvenement(idEvenement);
    });

    // bouton precedant controle de date
    $('#ef-btn-date-evenement-precedent').on('click', function () {
        if (estModeDeconnecte()) return;
        var position_liste = 0;
        var max = 0;
        var idEvenement = 0;

        $('#ef-date-evenement li').each(function (i, li) {
            var id = $(this).attr("actif");
            if (id != undefined)position_liste = i;
            max++;
        });

        switch (position_liste) {
            case max - 1:
                break;
            default:
                position_liste = position_liste + 2;
                idEvenement = $('#ef-date-evenement li:nth-child(' + position_liste + ')').attr('data-id-evenement');
                break;
        }

        ouvrirUrlEvenement(idEvenement);

    });

    // bouton suivant controle de date
    $('#ef-btn-date-evenement-suivant').on('click', function () {
        if (estModeDeconnecte()) return;
        var position_liste = 0;
        var max = 0;
        var idEvenement = 0;

        $('#ef-date-evenement li').each(function (i, li) {
            var id = $(this).attr("actif");
            if (id != undefined)position_liste = i;
            max++;
        });

        switch (position_liste) {
            case 1:
                idEvenement = $('#ef-date-evenement li:nth-child(1)').attr('data-id-evenement');
                break;
            default:
                idEvenement = $('#ef-date-evenement li:nth-child(' + position_liste + ')').attr('data-id-evenement');
                break;
        }

        ouvrirUrlEvenement(idEvenement);
    });

    // Permet d'execute
    $('#methode-cout').on('click', 'li', function () {
        if (estModeDeconnecte()) return;

        var li = $(this);
        var rapport = $(this).attr('data-type');
        var currentIdFormulaire = $('#current-id-formulaire').val();
        var currentIdTypeBatiment = $('#current-id-type-batiment').val();
        var currentIdBatiment = $('#current-id-batiment').val();
        var currentDateEvenement = $('#date-evenement').val();
        var idEvenement = $('#id-evenement').val();
        var idUe = $('#id-ue').val();
        var afficherBoutons;
        var url;
        var titre;
        var id;
        var typeBatimentStr = '';
        if (currentIdTypeBatiment == 1) {
            typeBatimentStr = 'résidentiels';
        }
        else if(currentIdTypeBatiment == 3) {
            typeBatimentStr = 'multirésidentiels';
        }
        else if(currentIdTypeBatiment == 4) {
            typeBatimentStr = 'non résidentiels';
        }

        if(rapport == 'cout-simplifie') {
            url = "/gestion-roles/methode-cout/detail-calcul/id-formulaire/" + currentIdFormulaire + "/id-batiment/" + currentIdBatiment + "/date/" + encodeURI(currentDateEvenement) + "/condense/0/";
            titre = "Méthode du coût";
            afficherBoutons = true;
            id = 'btn-methode-cout-imprimer';
        }
        else if(rapport == 'cout-classe') {
            url = "/gestion-roles/methode-cout/classe/id-formulaire/" + currentIdFormulaire + "/id-batiment/" + currentIdBatiment + "/date/" + encodeURI(currentDateEvenement) + "/";
            titre = "*DÉTERMINATION SYSTÉMATIQUE DE LA CLASSE - Bâtiments "+typeBatimentStr;
            afficherBoutons = true;
            id = 'btn-cout-classe-imprimer';
        }
        else if(rapport == 'cout-age-apparent') {
            url = "/gestion-roles/methode-cout/age/id-formulaire/" + currentIdFormulaire + "/id-batiment/" + currentIdBatiment + "/date/" + encodeURI(currentDateEvenement) + "/";
            titre = "Établissement systématique de l'âge apparent des bâtiments "+typeBatimentStr;
            afficherBoutons = false;
            id = '';
        }
        else if(rapport == 'cout-terrain') {
            url = "/gestion-roles/methode-cout/terrain/" + idUe + "/date/" + encodeURI(currentDateEvenement) + "/id-evenement/" + idEvenement + "/";
            titre = "Valeur terrain";
            afficherBoutons = false;
            id = '';
        }
        else if(rapport == 'cout-sommaire-evimbec') {
            var impression = 1; // une valeur 2 indique que l'on génère le pdf
            url = "/gestion-roles/methode-cout/b93-evimbec/unite-evaluation/" + idUe + "/id-batiment/" + currentIdBatiment + "/date/" + encodeURI(currentDateEvenement) + "/impression/" + impression + "/";
            titre = "*93 Sommaire de la méthode du coût";
            afficherBoutons = true;
            id = 'btn-sommaire-imprimer';
        }

        // On créer la fenêtre modal seulement si c'est la première fois qu'on l'ouvre.
        var boutons = [
                {
                    type: "print",
                    label: "Imprimer",
                    title: "Imprimer",
                    id: id,
                    classSupp: "btn-primary pull-left ",
                    afficher: afficherBoutons,
                    disabled: false
                },

                {
                    type: "cancel",
                    label: "Annuler",
                    title: "",
                    classSupp: "",
                    afficher: true
                },
                {
                    type: "save",
                    label: "Sauvegarder",
                    title: "Sauvegarder l'état actuel de ce formulaire",
                    id: "btn-sommaire-sauvegarder",
                    classSupp: "btn-primary",
                    afficher: afficherBoutons,
                    disabled: true
                }
        ];
        var variableModalCout = {
            id: "modal-cout",
            view: "/core/modal/",
            id_processus: "",
            titre: titre,
            titre_supp: "",
            module: "",
            contenuHTML: "",
            template: "",
            template_view: url,
            template_depart: "",
            template_depart_view: "",
            url: "",
            taille: "immense",
            resultat: "",
            resultat_depart: "",
            wizard: false,
            callback: function () {


                if (rapport == 'cout-simplifie') {
                    init_methode_cout();
                    $.ajax({
                        type: "POST",
                        url: "/gestion-roles/methode-cout/get-index/id-formulaire/" + currentIdFormulaire + "/",
                        dataType: 'html',
                        success: function (response) {
                            $('#modal-cout').find('.modal-title').append(response);
                        }
                    });

                    $("#btn-methode-cout-imprimer").on("click", function () {
                        $('#export-pdf-methode-cout-id-formulaire').val(currentIdFormulaire);
                        $('#export-pdf-methode-cout-date-evenement').val(JSON.stringify(currentDateEvenement));
                        $('#export-pdf-methode-cout-id-batiment').val(currentIdBatiment);
                        $("#frm-export-pdf-methode-cout").submit();
                    });
                    $("#btn-simplifie-excel-batiment").off("click").on("click", function() {
                        get_excel_detail_cout_base_1997(false, currentIdBatiment,
                            currentIdTypeBatiment, currentDateEvenement, idEvenement, idUe);
                    });

                    $("#btn-simplifie-excel-ue").off("click").on("click", function () {
                        get_excel_detail_cout_base_1997(true, currentIdBatiment,
                            currentIdTypeBatiment, currentDateEvenement, idEvenement, idUe);
                    });
                }

                if (rapport == 'cout-sommaire-evimbec') {
                    init_methode_cout();
                    $("#btn-methode-cout-xls").on("click", function () {
                                var url = "/gestion-roles/methode-cout/export_xls_adi/" + idUe + "/id-batiment/" + currentIdBatiment + "/date/" + encodeURI(currentDateEvenement) + "/id-type-batiment/" + 0 + "/impression/" + 1 + "/";
                                wait.start();
                                $.ajax({
                                    type: "POST",
                                    url: url,
                                    dataType: 'html',
                                    success: function (response) {
                                        infos.ajouterMessageToast({
                                            message: response,
                                            messageDuree: 5000
                                        });
                                        wait.stop();
                                    }
                                });
                    });
                }

                if (rapport == 'cout-classe') {
                    $("#btn-cout-classe-imprimer").on("click", function () {
                        $('#export-pdf-cout-classe-id-formulaire').val(currentIdFormulaire);
                        $('#export-pdf-cout-classe-date-evenement').val(JSON.stringify(currentDateEvenement));
                        $('#export-pdf-cout-classe-id-batiment').val(currentIdBatiment);
                        $("#frm-export-pdf-classe").submit();
                    });
                }

                if (rapport == 'cout-terrain') {
                    controlesFormulaires.redimentionnerTextarea();
                    $('#btn-calculer-terrain').on('click', function () {
                        var params = {id_ue: idUe, date_evenement: currentDateEvenement};
                        $.ajax({
                            type: "POST",
                            url: "/gestion-roles/methode-cout/calculer-terrain/",
                            data: params,
                            dataType: 'json',
                            success: function (response) {
                                // rafraichir le popup
                                fenetreModal.fermerModal('modal-cout');
                                li.click();
                            }
                        });
                    });

                    var options = {blocsContainer: $('#modal-cout #contenu')};
                    initBlocsCharges(null, null, options);
                    controlesFormulaires.detecterChangementsFormulaire();
                    formaterMonnaie($('#modal-cout').find('input.money'), 0);

                    $("#btn-sommaire-sauvegarder").on("click", function () {
                        saveBlocs(null, null, {
                            modeSave: ModeSave.VALEUR_TERRAIN,
                            blocsContainer: $('#modal-cout #contenu')
                        });
                    });
                }
            },
        };
        // 23826: Ajout d'un bouton d'export Excel dans le cas du sommaire, à côté du bouton d'impression.
        if (rapport === 'cout-simplifie') {
            var boutons_cout_simplifie = [{
                label: "Excel du bâtiment",
                title: "Excel du bâtiment",
                id: "btn-simplifie-excel-batiment",
                classSupp: "btn-primary pull-left margin-left-5",
                afficher: afficherBoutons,
                disabled: false,
                icone: "fa-file-excel-o"
            }, {
                label: "Excel de l'UE",
                title: "Excel de l'UE",
                id: "btn-simplifie-excel-ue",
                classSupp: "btn-primary pull-left margin-left-5",
                afficher: afficherBoutons,
                disabled: false,
                icone: "fa-file-excel-o"
            }];

            $.merge(boutons, boutons_cout_simplifie);
        } else if(id == "btn-sommaire-imprimer") {
            var boutons_sommaire_impression = [{
                type: "print",
                label: "Imprimer avec indicateurs",
                title: "Imprimer avec indicateurs",
                id: "btn-sommaire-imprimer-indicateurs",
                classSupp: "btn-primary pull-left margin-left-5",
                afficher: afficherBoutons,
                disabled: false,
                icone: "fa-print"
            }, {
                label: "Excel",
                title: "Exporter en Excel",
                id: "btn-methode-cout-xls",
                classSupp: "btn-primary pull-left margin-left-5",
                afficher: afficherBoutons,
                disabled: false,
                icone: "fa-file-excel-o"
            }];

            $.merge(boutons, boutons_sommaire_impression);
        }
        variableModalCout.boutons = boutons;
        fenetreModal.creerModal(variableModalCout, {read_only: "True"});
    });
    // #20802: pour les comportements de popover bloc11 calculator
    $('.popover-dismiss').popover({
        trigger: 'focus'
    });
    window.editeurFicheBoutonsInitialized = true;
    console.log('✓ Boutons initialisés avec succès');
}

function ouvrirUrlEvenement(idEvenement) {
    var currentIdBatiment = $('#current-id-batiment').val();
    var currentIdFormulaire = $('#current-id-formulaire').val();
    var currentIdTypeBatiment = $('#current-id-type-batiment').val();
    var url = "/gestion-roles/editeur-fiche/evenement/" + idEvenement + "/?id_batiment=" + currentIdBatiment + "&id_formulaire=" + currentIdFormulaire + "&id_type_batiment=" + currentIdTypeBatiment;
    window.open(url, '_self');
}

function afficherPastilleNouveauBatiment(idBatiment, idFormulaire, idTypeBatiment, maxNoBatiment, idTypeBatimentText, iconFiche) {
    $('ul.ef-batiment-list').append('' +
        '<li>' +
        '<a class="batiment" href="" data-rel="" id-batiment="' + idBatiment + '" no-batiment="' + maxNoBatiment + '" id-formulaire="' + idFormulaire + '" id-type-batiment="' + idTypeBatiment + '"descriptif=""> ' +
        '<img class="photo_arrondie" src="' + url_non_disponible_mini + '" style="height: 125px;width: 125px" data-dismiss="modal"> ' +
        '</a>' +
        '<div class="tools tools-top in"> ' +
        '<a class="popover-notitle" href="#" data-rel="popover" data-placement="bottom" data-content="' + idTypeBatimentText + '" data-original-title="" title=""> <i class="' + iconFiche + '" title="' + idTypeBatimentText + '"></i></a> ' +
        '<a href="#"><i class="" title="' + maxNoBatiment + '">' + maxNoBatiment + '</i></a> ' +
        '<a class="popover-notitle" href="#" data-rel="popover" data-placement="bottom" data-content="Aucune description" data-original-title="" title="Aucune description"><i class="ace-icon fa fa-info" title="Aucune description"></i></a> ' +
        '</div>' +
        '</li>');
    wait.stop('spin-nouveau-batiment-div');
    $('#spin-nouveau-batiment').remove();

}

function initOuvrirFiche(idBatiment, idTypeBatiment, titreFiche, idEvenement, dateEvenement, idFormulaire) {
    console.log("In initOuvrirFiche: idBatiment: " + idBatiment + ", idTypeBatiment: " + idTypeBatiment);
    if (window.isRunningInApp === undefined) {
        window.isRunningInApp = isRunningInIonicApp()
    }
    setEnteteFormulaire($('#headerTitre'), idBatiment, idFormulaire, $('#id-ue').val(), $('#infobox-identifiant'));
    updateBarreOutilsFiche(idFormulaire);
    if (window.isRunningInApp) {
        offlineMode(idBatiment, idTypeBatiment, idEvenement, dateEvenement, idFormulaire);
    } else {
        ouvrirFicheTaj(idBatiment, idTypeBatiment, idEvenement, dateEvenement, idFormulaire);
    }
    calculerHauteurAncre();
}


function initLienBloc(containerLienBloc) {
    var lienBlocTimeout = null;
    // se positionner sur le bloc et l'ouvrir s'il est collapsé

    containerLienBloc.click(function (e) {
        // Prevent default navigation
        e.preventDefault();
        e.stopPropagation();

        var nomBloc = $(this).attr('nom-bloc');
        console.log("initLienBloc", nomBloc);

        // Add a small delay to ensure the DOM is ready
        setTimeout(() => {
            scrollToElement(nomBloc);
        }, 100);

        if (blocCollapsed(nomBloc)) {
            blocExpand(nomBloc);

            if (lienBlocTimeout) {
                clearTimeout(lienBlocTimeout);
            }

            // si le panel est collapsé et dans le bas complètement, ça permet d'attendre le temps qu'il s'expand et ensuite scroller en bas de la page complètement
            lienBlocTimeout = setTimeout(function () {
                scrollToElement(nomBloc);
                lienBlocTimeout = null;
            }, 500);
        }
    });
}

function nombreValidationPropagation(type) {
    var nombre = 0;
    $.each(tree_data['validations']['additionalParameters']['children'][type]['additionalParameters']['children'], function (index, children) {
        nombre += Object.keys(children['additionalParameters']['children']).length;
    });
    return nombre;
}

function traiterErreursPropagation(form, erreurs) {
    afficherValidationPropagation(form, erreurs, 'erreurs');
    tree_data['validations']['additionalParameters']['children']['erreurs'].name = 'Erreurs (' + nombreValidation('erreurs') + ')';
}

function traiterAvertissementPropagation(form, avertissements) {
    afficherValidationPropagation(form, avertissements, 'avertissements');
    tree_data['validations']['additionalParameters']['children']['avertissements'].name = 'Avertissements (' + nombreValidation('avertissements') + ')';
}

function afficherValidationPropagation(form, validations, type) {
    var formInitial = form;
    var estBloc = form.is('.blocForm');
    var idBloc = estBloc ? form.attr('id_bloc').substr(0, 2) : form.closest('.champs-multiple').attr('id').substr(1, 2);
    var idBlocInt = parseInt(idBloc); // utile pour mettre les blocs en ordre car avec le texte '08' vs '15', le '15 vient avant
    var idBlocIntInitial = idBlocInt;
    var id_batiment = form.attr('id_batiment');
    var id_ue = $('#wizard').attr('id-ue');
    if (id_batiment == undefined && form.closest('[id^=accordion-batiment-]').length == 1) {
        var splitId = form.closest('[id^=accordion-batiment-]').attr('id').split('-');
        id_batiment = idBlocInt != 0 ? splitId[2] : id_ue;
    }
    var blocintBat = id_batiment.concat(idBlocInt);
    var blocintBatInitial = blocintBat;
    var titreBlocbatiment = id_batiment != id_ue ? 'Bâtiment '.concat(id_batiment): idBlocInt == 4 ? ' Terrain' : ' Renseignements administratifs' ;
    var titreBlocbatimentInitial = titreBlocbatiment;
    var titreidBlocbatiment = 'titre'.concat(idBlocInt == 4 ? blocintBat: id_batiment) ;
    var folderBloc = 'Bloc ' + idBloc;
    var folderBlocInitial = folderBloc;
    var treeDataBloc = typeof (tree_data) !== 'undefined' ? tree_data['validations']['additionalParameters']['children'][type]['additionalParameters']['children'] : {};
    var treeDataSousBloc = {};

    var nomBlocZoom = estBloc ? form.attr('id') : form.closest('.blocForm').attr('id');
    var nomBlocZoomInitial = nomBlocZoom;
    var nomBloc = estBloc ? form.attr('id') : form.closest('.champs-multiple').attr('id'); // sert pour différencier d'où provienne les erreurs et les rendre uniques pour le treeData
    var iconeClass = 'red';
    var couleurTexte = 'red';
    if (type === 'avertissements') {
        iconeClass = 'orange';
        couleurTexte = '#d58512';
    }
    var validationExiste = Object.keys(validations).length > 0;
    if (estBloc)
        validationExiste = ('params' in validations && Object.keys(validations).length > 1) ||
            (!('params' in validations) && Object.keys(validations).length > 0);

    if (validationExiste) {
        var noErreur = 1;
        $.each(validations, function (nomChamp, erreur) {
            if (nomChamp != 'params') {
                // reprendre les données initiales à chaque boucle
                form = formInitial;
                idBlocInt = idBlocIntInitial;
                blocintBat = blocintBatInitial;
                nomBlocZoom = nomBlocZoomInitial;
                folderBloc = folderBlocInitial;
                titreBlocbatiment = titreBlocbatimentInitial ;
                // si c'est un bloc d'une fiche, il ne faut pas trouver les champs dans les sous-blocs
                var exceptionsFormControl = [];
                if (estBloc) {
                    exceptionsFormControl = form.find('.champs-multiple .form-control');
                } else {
                    exceptionsFormControl = form.find('.suppression-ligne .form-control, .suppression-ligne-sauvegardee .form-control');
                }
                var champs = form.find('.form-control[name="' + nomChamp + '"]').not(exceptionsFormControl);

                // si l'erreur arrive sur un sélecteur ayant un input associé, il faut trouver le(s) input(s) pour afficher la notification
                if (champs.is('select')) {
                    var input = champs.closest('.blocForm').find('input[parent="' + champs.attr('name') + '"]');
                    if (input.length > 0) {
                        champs = input;
                    }
                }

                // si c'est un champ imbriqué, il faut construire le nom du champ avec un point(.) pour le retrouver
                if (champs.length == 0 && erreur instanceof Object) {
                    $.each(erreur, function (nom, textes) {
                        var nomChampTemp = nomChamp + '.' + nom;
                        var champsTemp = form.find('.form-control[name="' + nomChampTemp + '"]').not(exceptionsFormControl);
                        if (champsTemp.length > 0) {
                            afficherErreurValidationPropagation(form, champsTemp, textes);
                        }
                    });
                }

                var erreurListe = 'texte' in erreur ? erreur['texte'] : erreur;
                if (erreurListe.length) {
                    afficherErreurValidationPropagation(form, champs, erreurListe);
                }

                if ('sous_bloc' in erreur) {
                    // mettre en ordre le nom des sous-blocs
                    var dictSousBloc = $.extend({}, erreur['sous_bloc']);
                    var keysSousBlocSorted = Object.keys(dictSousBloc).sort(function (a, b) {
                        var contentA = a;
                        var contentB = b;
                        return (contentA < contentB) ? -1 : (contentA > contentB) ? 1 : 0;
                    });
                    erreur['sous_bloc'] = {};
                    for (var i = 0; i < keysSousBlocSorted.length; i++) {
                        var key = keysSousBlocSorted[i];
                        erreur['sous_bloc'][key] = dictSousBloc[key];
                    }

                    $.each(erreur['sous_bloc'], function (sousBlocKey, sousBlocValue) {
                        // reprendre les données initiales à chaque boucleg
                        idBlocInt = idBlocIntInitial;
                        blocintBat = blocintBatInitial ;
                        nomBlocZoom = nomBlocZoomInitial;
                        folderBloc = folderBlocInitial;
                        titreBlocbatiment = titreBlocbatimentInitial;
                        form = formInitial;
                        // si un sous-bloc est précisé, il faut le chercher ainsi que le champ correspondant
                        form = form.find('#' + sousBlocKey);
                        // si c'est un sous-bloc qui n'est pas dans ce bloc, chercher le sous-bloc dans le reste de la fiche
                        if (form.length == 0) {
                            var divBatiment = formInitial.closest('[id^=accordion-batiment-]');
                            if (divBatiment.length) { // DM 2019-04-01: dans l'écran propagation, ne pas prendre la portion AVANT
                                form = divBatiment.find('.apres-container #' + sousBlocKey);
                            } else {
                                form = $('#' + sousBlocKey);
                            }

                            if (form.length != 0) {
                                idBlocInt = parseInt(form.closest('.blocForm').attr('id_bloc').substr(0, 2));
                                nomBlocZoom = form.closest('.blocForm').attr('id');
                                folderBloc = 'Bloc ' + form.attr('id').substr(1, 2);
                                blocintBat = id_batiment.concat(idBlocInt) ;

                            }
                        }
                        if (form.length) {
                            var containerSousBloc = form.find('.sous-bloc-form');
                            var inputDansLigneSupprimee = containerSousBloc.find('.suppression-ligne .form-control, .suppression-ligne-sauvegardee .form-control');
                            // chercher le champ dans les sous-blocs mais il ne faut pas afficher la notification sur une nouvelle ligne de sous-bloc, ni sur une ligne supprimée
                            champs = containerSousBloc.not('.sous-bloc-form.nouvelle-ligne').find('.form-control[name="' + nomChamp + '"]').not(inputDansLigneSupprimee);
                            if (champs.length == 0) {
                                // on veut afficher l'erreur sur la nouvelle ligne
                                if (nomChamp == 'nouvelle-ligne') {
                                    containerSousBloc = containerSousBloc.filter('.sous-bloc-form.nouvelle-ligne');
                                }
                                // on n'a pas de champ mais on va pointer sur le 1er input des sous-blocs disponibles, y compris une nouvelle ligne de sous-bloc
                                champs = containerSousBloc.find(':input:not([type="hidden"], button)').first();
                            } else {
                                // on veut pointer sur le input ayant la valeur précisée
                                if ('valeur' in sousBlocValue) {
                                    champs = champs.filter(function () {
                                        for (var index in sousBlocValue['valeur']) {
                                            if (sousBlocValue['valeur'].hasOwnProperty(index) && $(this).val() == sousBlocValue['valeur'][index]) {
                                                return true;
                                            }
                                        }
                                    });
                                }
                                if ('no_ligne' in sousBlocValue) {
                                    // on veut pointer le input sur la ligne précisée
                                    champs = champs.filter(function () {
                                        for (var index in sousBlocValue['no_ligne']) {
                                            if ('no_ligne' in sousBlocValue) {
                                                if (sousBlocValue['no_ligne'].hasOwnProperty(index) &&
                                                    $(this).closest('.sous-bloc-form').attr('no-ligne') == (parseInt(sousBlocValue['no_ligne'][index]) + 1).toString()) {
                                                    return true;
                                                }
                                            }
                                        }
                                    });
                                }
                            }
                            afficherErreurValidationPropagation(form, champs, sousBlocValue['texte']);
                        } else {
                            form = formInitial;
                            afficherErreurValidationPropagation(form, champs, sousBlocValue['texte']);
                        }
                    });
                }

                function afficherErreurValidationPropagation(form, champs, textes) {
                    // il faut que le form existe, sinon, on ne continue pas pour l'affichage
                    if (form.length !== 0) {
                        var aucunChamp = champs.length === 0;
                        // si le sous-bloc n'est pas dans le tree, on le crée
                        if (!(titreidBlocbatiment in treeDataBloc)) {
                            treeDataBloc[titreidBlocbatiment] = {
                                name: titreBlocbatiment,
                                type: 'folder',
                                'icon-class': iconeClass
                            };
                            treeDataBloc[titreidBlocbatiment]['additionalParameters'] = {'children': {}};
                        }
                            treeDataSousBloc = typeof (treeDataBloc) !== 'undefined' ? treeDataBloc[titreidBlocbatiment]['additionalParameters']['children'] : tree_data['validations']['additionalParameters']['children'][type]['additionalParameters']['children'];

                              if (!(blocintBat in treeDataSousBloc)) {

                            // on crée le sous-dossier pour recevoir les erreurs de ce bloc, s'il n'est pas déjà créé
                            treeDataSousBloc[blocintBat] = {name: folderBloc, type: 'folder', 'icon-class': iconeClass};
                            // on crée le sous-dossier pour recevoir les erreurs de ce bloc, s'il n'est pas déjà créé
                            treeDataSousBloc[blocintBat]['additionalParameters'] = {'children': {}};
                              }
                        // un champ peut avoir plus d'un message alors on boucle pour avoir tous ses messages
                        for (var index = 0; index < textes.length; index++) {

                            // si le même message est affiché, on ne l'affiche pas de nouveau
                            var infoMessage = chercherMessage(treeDataSousBloc[blocintBat]['additionalParameters']['children'], textes[index], noErreur, index > 0);
                            var messageTrouve = infoMessage.messageTrouve;
                            noErreur = infoMessage.noErreur;

                            // afficher le numéro d'erreur et le texte de l'erreur dans le bloc, s'il y a lieu
                            erreursAjax.afficherErreurChampsFiche(form, champs, textes[index], type, noErreur, aucunChamp, messageTrouve);

                            if (!messageTrouve) {
                                //ajouter un lien pour aller sur le bloc qui a l'erreur
                                var lienTexte = aucunChamp ? textes[index] : noErreur + '. ' + textes[index];
                                var lienControle = '<a class="lien-bloc-validation" style="color:' + couleurTexte + '" href="#!" nom-bloc="' + nomBlocZoom + '" id-bloc="' + idBloc + '" id-batiment="' + id_batiment + '">' + lienTexte + '</a>';

                                // on ajoute chaque erreur dans le tree data
                                // on ajoute le nom du bloc pour différencier un champ qui viendrait du bloc et du sous-bloc en même temps
                                // on ajoute l'index pour différencier un champ qui aurait plusieurs messages
                                // on ajoute le no d'erreur pour des blocs/sous-blocs qui auraient des messages différents
                                var noErreurTemp = aucunChamp ? 999 : noErreur;
                                var childrenKey = nomBloc + '_' + nomChamp + '_' + index + '_' + noErreurTemp;
                                treeDataSousBloc[blocintBat]['additionalParameters']['children'][childrenKey] = {
                                    name: lienControle,
                                    type: 'item',
                                    noErreur: noErreurTemp // sert à chercher le prochain numéro d'erreur et mettre les messages en ordre de numéro
                                                           // le numéro '999' est assigné dans le cas où il n'y a pas de champ précisé
                                };
                                // on met à jour le nombre d'erreurs pour ce bloc
                                var nombreErreur = Object.keys(treeDataSousBloc[blocintBat]['additionalParameters']['children']).length;
                                treeDataSousBloc[blocintBat].name = folderBloc + ' (' + nombreErreur + ')';
                            }
                        }
                    }
                    var nombreErreurbloc = Object.keys(treeDataBloc[titreidBlocbatiment]['additionalParameters']['children']).length;
                    treeDataBloc[titreidBlocbatiment].name = titreBlocbatiment + ' (' + nombreErreurbloc + ')';

                }
            }
        });

        // mettre en ordre: les messages avec des numéros en premier, les messages sans numéros par la suite
        if (idBlocInt in treeDataSousBloc) {
            var list = $.extend({}, treeDataSousBloc[blocintBat]['additionalParameters']['children']);
            var keysSorted = Object.keys(list).sort(function (a, b) {
                var contentA = list[a]['noErreur'];
                var contentB = list[b]['noErreur'];
                return (contentA < contentB) ? -1 : (contentA > contentB) ? 1 : 0;
            });

            treeDataSousBloc[blocintBat]['additionalParameters']['children'] = {};
            for (var i = 0; i < keysSorted.length; i++) {
                var key = keysSorted[i];
                treeDataSousBloc[blocintBat]['additionalParameters']['children'][key] = {
                    name: list[key]['name'],
                    type: 'item',
                    noErreur: list[key]['noErreur']
                };
            }
        }
    }
}

function initvalidationdialogpropagation(blocsContainer) {
    var dictLiensBloc = {};

    var blocs = $('.step-pane.active').find('.apres-container .blocForm');
    $.each(blocs, function (index, bloc) {
        var id = $(bloc).attr('id');
        var idBloc = $(bloc).attr('id_bloc');
        var titreBloc = $(bloc).attr('titre');
        var id_batiment = $(bloc).attr('id_batiment');
        // ajouter l'info de chaque bloc dans le dict pour les liens de la table des matières
        dictLiensBloc[idBloc] = {'id': id, 'id_batiment': id_batiment, 'titreBloc': titreBloc};
    });

    ordonnerBlocs(false);

    // on met en ordre ascendant les numéros de blocs
    var keys = Object.keys(dictLiensBloc);
    keys.sort();
    var liensBlocs = '';

    // ajouter un hyperlien de chaque bloc en haut de tous les blocs (table des matières)
    for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        var value = dictLiensBloc[key];

        var caption = key.substr(0, 2);
        var id_blocpropagation = key;
        if (caption == '90') {
            caption = 'Autres documents';
        }

        liensBlocs += '<a class="lien lienBloc" title="' + value['titreBloc'] + '" href="#!" nom-bloc="' + value['id'] + '" id-bloc="' + id_blocpropagation + '" id-batiment="' + value['id_batiment'] + '">' + caption + '</a>';
    }

    // créer un dialogue ayant un tree view qui affiche les validations
    var validationDialogInstance = $('#treeViewValidation').dialog("instance");
    if (validationDialogInstance == undefined) {
        var treeDataSource = new DataSourceTree({data: tree_data});
        $('#treeViewValidation')
            .ace_tree({
                dataSource: treeDataSource,
                multiSelect: true,
                cacheItems: false,
                loadingHTML: '<div class="tree-loading"><i class="ace-icon fa fa-refresh fa-spin blue"></i></div>',
                'open-icon': 'ace-icon fa fa-folder-open',
                'close-icon': 'ace-icon fa fa-folder',
                'selectable': true,
                'selected-icon': null,
                'unselected-icon': null
            })
            .on('opened.fu.tree', function (event, data) {
                // pour chaque dossier ouvert, initialiser le lien vers le bloc
                if (data.hasOwnProperty('name') && data.name.indexOf('Bloc') === 0) {
                    var lienBloc = $('.tree-folder-name:contains(' + data.name + ')').closest('.tree-folder').find('.lien-bloc-validation');
                    initLienBlocPropagation(blocsContainer, lienBloc);
                }
            })
            .dialog({
                autoOpen: false,
                width: 500,
                maxHeight: 600,
                resizable: false,
                fluid: true,
                open: function (event, ui) {
                    $(this).tree('refreshAll');
                }
            });
    } else {
        effacerValidation();
        fermerFenetreValidation();
        // fermer les messages affichés en haut de la fiche
    }

    // afficher les hyperliens de la table des matières
    $('#liens-blocs').html(liensBlocs);
    $('#entete-fixe-propagation').insertBefore('#propagation-entete');
    var liensvalidation = '<a id="lienValidationErreur" class="lien" href="#!" title="Afficher les validations">Liste des validations</a>';
    $('#entetelienvalidation').html(liensvalidation);

    $('#treeViewValidation').parent().insertAfter('#entete-fixe-propagation');
    initLienBlocPropagation(blocsContainer, $('.lienBloc'));

    // afficher un dialogue avec les erreurs de validation en cliquant sur le lien
    $('#lienValidationErreur').off("click").on("click", function () {
        afficherFenetreValidation();
    });
}


function initLienBlocPropagation(blocsContainer, containerLienBloc) {
    var lienBlocTimeout = null;
    // se positionner sur le bloc et l'ouvrir s'il est collapsé
    containerLienBloc.click(function () {
        var nomBloc = $(this).attr('nom-bloc');
        var idBloc = $(this).attr('id-bloc');
        var blocsContainerFiche = blocsContainer.find('[id^=accordion-batiment-' + $(this).attr('id-batiment') + '-]');
        if (blocsContainerFiche.length <= 0) {
            blocsContainerFiche = blocsContainer.find('[id^=accordion-batiment-0-0-]');
        }
        if (lienBlocTimeout) {
            clearTimeout(lienBlocTimeout);
        }

        // si le panel est collapsé et dans le bas complètement, ça permet d'attendre le temps qu'il s'expand et ensuite scroller en bas de la page complètement
        lienBlocTimeout = setTimeout(function () {
            assurerBlocOuvert(blocsContainerFiche, idBloc);
            lienBlocTimeout = null;
            var conteneurOffset = Math.abs($('#modal-step-contents > .active .contenu-principal').offset().top, 10) + 400;
            var scrollToErreur = $("#" + nomBloc).offset().top - WIZARD_ENTETE.taille + conteneurOffset;
            $('#modal-step-contents').slimScroll({
                scrollTo: scrollToErreur,
                animate: true
            });
        }, 500);
    });
}

function btnNaviguationDateEvenements() {
    var max = 0;
    var position_liste = 0;

    $('#ef-date-evenement li').each(function (i, li) {
        var id = $(this).attr("actif");
        if (id != undefined)position_liste = i;
        max++;
    });

    switch (position_liste) {
        case 0:
            $("#ef-btn-date-evenement-suivant").attr("disabled", "disabled");
            break;
        case max - 1:
            $("#ef-btn-date-evenement-precedent").attr("disabled", "disabled");
            break;
        default:
            $("#ef-btn-date-evenement-suivant").removeAttr("disabled", "disabled");
            $("#ef-btn-date-evenement-precedent").removeAttr("disabled", "disabled");
            break;
    }
}


function initEventsRemarques() {

    // chercher la remarque associée dans la fiche et lui assigner la valeur de la remarque saisie
    $('#remarques').find('textarea[name="remarque"]').on('change', function () {
        var idBloc = $(this).closest('.champs-multiple').attr('id-bloc');
        var text = $(this).val().trim().split("\n");
        $.each($('#blocs-container').find('.blocForm[id_bloc="' + idBloc + '"] [id$="remarque"] .sous-bloc-form[bloc-editable="True"]').not('.sous-bloc-form.nouvelle-ligne'), function () {
            var ligne = $(this);
            // vérifier que la ligne a des données pour ne pas obliger de l'inserer de nouveau
            if ($(this).find('input.ctrl-suppression:checked').length == 0 && $(this).find('.suppression-ligne').length == 0) {
                if (!ligneEstSansDonnee(ligne)) {
                    $(this).find('input.ctrl-suppression').click();
                    $(this).hide();
                }
            }
        });
        for (let i = 0; i < text.length; i++) {
            if (text[i] !== '') {
                $('#blocs-container').find('.blocForm[id_bloc="' + idBloc + '"] [id$="remarque"] .sous-bloc-form.nouvelle-ligne input[name="remarque"]')
                    .val(text[i])
                    .trigger('change', 'eventRemarques');
            }
        }
    });
}

function afficherFenetreValidation() {
    // on met à jour le treeView de validation si le dialogue est déjà ouvert
    var dialogueEstOuvert = $("#treeViewValidation").dialog("isOpen");
    if (dialogueEstOuvert) {
        $('#treeViewValidation').tree('refreshAll');
    }
    ouvrirDialogue($('#treeViewValidation'));
}

function fermerFenetreValidation() {
    // on ferme le dialogue de validation si le dialogue est déjà ouvert
    var dialogueEstOuvert = $("#treeViewValidation").dialog("isOpen");
    if (dialogueEstOuvert) {
        $('#treeViewValidation').dialog('close');
    }
}

function majBadgesValidation() {
    var lienValidationErreur = $("#lienValidationErreur");
    lienValidationErreur.attr("data-nb-avertissements", nombreValidation("avertissements"));
    lienValidationErreur.attr("data-nb-erreurs", nombreValidation("erreurs"));

    if(nombreValidation("erreurs") + nombreValidation("avertissements") > 0) {
        if(nombreValidation("erreurs") > 0) {
            lienValidationErreur.addClass("text-red");
        } else if(nombreValidation("avertissements") > 0) {
            lienValidationErreur.addClass("text-warning-dark");
        }
        lienValidationErreur.addClasses(["text-decoration-underline", "focus-temp"]);
        setTimeout(function() {
            lienValidationErreur.removeClass("focus-temp");
        }, 3000);
    } else {
        lienValidationErreur.removeClasses(["text-decoration-underline", "text-red", "text-warning-dark"]);
    }
    $('#treeViewValidation').tree('refreshAll');
}

function afficherFenetreRemarques() {
    // on positionne le dialogue toujours en haut et en-dessous des liens des blocs
    // ATTENTION: il faut ouvrir le dialogue avant de fermer les accordions et d'ouvrir l'accordion selon la composante,
    //            sinon, ça met une largeur à l'accordéon suivant de celui ouvert et l'icône se déplace à droite complêtement
    ouvrirDialogue($('#remarques'));
}

function afficherMasquerErreurB79ImputerTemps(response) {
    let b79key = Object.keys(response).filter(k => k.startsWith('b79-attestation'))[0];
    let bool_afficher = b79key in response && 'erreurs' in response[b79key] && 'impute_temps' in response[b79key].erreurs;
    $('#imputer_temps_warning').toggleClass('hidden', !bool_afficher);
    $('.afficher-modal-imputer-temps').toggleClass("focus-temp", bool_afficher);
}


// source: Responsive jQuery UI Dialog, https://gist.github.com/jasonday/5550879
function fluidDialog() {
    var $visible = $(".ui-dialog:visible");
    // each open dialog
    $visible.each(function () {
        var $this = $(this);
        var $dialogContent = $this.find(".ui-dialog-content");
        var dialog = $dialogContent.dialog('instance');
        // on le max-width du contenu du dialogue à 100% pour suivre la grandeur du dialogue
        $dialogContent.css('max-width', '100%');
        // on définit l'option maxWidth du dialogue avec l'option width. Si on ne le fait pas, le contenu du dialogue reste à la grandeur width
        dialog.options.maxWidth = dialog.options.width;
        if (dialog.options.fluid) {
            var wWidth = $(window).width();
            // check window width against dialog width
            if (wWidth < dialog.options.maxWidth + 50) {
                // keep dialog from filling entire screen
                $this.css("max-width", "90%");
            } else {
                // fix maxWidth bug
                $this.css("max-width", dialog.options.maxWidth);
            }
            //reposition dialog
            dialog.option("position", dialog.options.position);

        }
    });
}


function calculerHauteurAncre() {
    const hauteurEnteteFixe = $(`#entete-fixe`).outerHeight(true);
    $('#liens-blocs').css('top', `${hauteurEnteteFixe}px`);
}

function ajouterSlimScrollEF(container, hauteur, scrolldown) {
    scrolldown = typeof scrolldown !== 'undefined' ? scrolldown : false;

    if (container.length > 0 && container.height() >= hauteur) {

        // placer le slimScroll pour les sous-blocs seulement, donc l'entête restera fixe
        var containerClass = 'container-sous-bloc-form';
        var containerSousBloc = container.find('.' + containerClass);
        if (!containerSousBloc.length) {
            container.find('.sous-bloc-form').wrapAll('<div class="' + containerClass + '"></div>');
            containerSousBloc = container.find('.' + containerClass);
            containerSousBloc.addClass('gestion-scroll');
        }

        var hauteurModalContentZoom = $('#modal-zoom').find('.modal-content').height() - 130;
        if (scrolldown) {
            var hauteurResultat = $('#modal-zoom').length > 0 ? hauteurModalContentZoom: hauteur;
            containerSousBloc.css('overflow-y', 'scroll');
            containerSousBloc.css('height', hauteurResultat);
        }
    }
}

function rendreChampMultipleOrdonnable(container, selecteurInputOrdre) {
    if(!container.find('.sous-bloc-form-sortable').length) {
        container.find('.sous-bloc-form').wrapAll('<div class="sous-bloc-form-sortable-container"></div>');
        container.find('.sous-bloc-form').addClass('sous-bloc-form-sortable');

        var userAgent = navigator.userAgent;
        var isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints;

        if ((/Touch|Tablet|Windows NT/.test(userAgent) && /Windows/.test(userAgent)) && isTouchDevice) {
            container.find('.sous-bloc-form-sortable-container').evb_sortable({
                nodes: `.sous-bloc-form:not(.${CLASSE_NOUVELLE_LIGNE})`,
                handle: ".sortable-handle-logo",
                update: function() {
                    reordonnerChampsMultiples(container, selecteurInputOrdre);
                }
            });
        } else {
            container.find('.sous-bloc-form-sortable-container').sortable({
                items: `.sous-bloc-form:not(.${CLASSE_NOUVELLE_LIGNE})`,
                handle: ".sortable-handle-logo",
                update: function() {
                    reordonnerChampsMultiples(container, selecteurInputOrdre);
                }
            });
        }
        container.find('.sous-bloc-form-sortable').prepend(`
            <div class="sortable-handle-logo">
                <div class="sortable-handle-logo-box"></div>
                <div class="sortable-handle-logo-box"></div>
                <div class="sortable-handle-logo-box"></div>
                <div class="sortable-handle-logo-box"></div>
                <div class="sortable-handle-logo-box"></div>
                <div class="sortable-handle-logo-box"></div>
            </div>
        `);
    }
}

function reordonnerChampsMultiples(container, selecteurInputOrdre) {
    container.find(`.sous-bloc-form-sortable:not(.${CLASSE_NOUVELLE_LIGNE})`).each(function (index) {
        let inputOrdre = $(this).find(selecteurInputOrdre);
        let nouvelOrdre = index + 1;
        if(inputOrdre.val() != nouvelOrdre) {
            inputOrdre.val(nouvelOrdre);
            inputOrdre.addClass(CLASSE_VALEUR_MODIFIEE);
        }
    });
}

function sauvegarderSousBloc(ligne, idBatiment, dateEvenement, idFormulaire, callback) {
    // On vérifie d'abord si la ligne a été éditée afin de ne pas la sauvegarder inutilement
    if (sousBlocEstModifie(ligne)) {
        var paramsLigne = getParamsLigneSousBloc(ligne);
        var params = paramsLigne.params;
        var ligneStatut = paramsLigne.ligneStatut;
        var nomBloc = ligne.closest('.champs-multiple').attr('id');
        var index = ligne.closest('.champs-multiple').find('.sous-bloc-form').index(ligne);
        var paramsOptionnels = [];

        // DM: HACK en attendant de trouver une façon plus générique
        var modalCommunication = $('#modal_communication');
        if (modalCommunication.length > 0) {
            var idProcessus = $('#communication-sous-bloc .sous-bloc-form').attr('id-model-instance');
            paramsOptionnels.push({name: 'id_processus', value: idProcessus});

            var idMunicipalite = $('#communication-sous-bloc .sous-bloc-form [name=municipalite]').val();
            paramsOptionnels.push({name: 'id_municipalite', value: idMunicipalite});

            idBatiment = undefined;
            idFormulaire = -1;
            dateEvenement = ligne.find('[name=date_debut]').val();
        }
        params.push({'name': 'id_formulaire', 'value': idFormulaire});

        ajaxSauvegarderSousBloc(ligne, params, true, ligneStatut, nomBloc, idBatiment, dateEvenement, idFormulaire, index, paramsOptionnels, callback);
    }
}

function comparerDeuxArrays(array1, array2, bothSide) {

    if (array2 == null) {
        return array1;
    }

    // array1 a moins d'éléments que array2
    var arrayResult = $.grep(array2, function (element) {

        return $.inArray(element, array1) == -1;

    });

    // array2 a moins d'éléments que array1
    if (bothSide && arrayResult.length == 0) {
        arrayResult = $.grep(array1, function (element) {

            return $.inArray(element, array2) == -1;

        });
    }

    return arrayResult;
}

function toggleOuvrirFermerBlocs(bouton) {


    var blocsOuverts = bouton.attr('blocs-ouverts');
    var htmlBouton = bouton.html();
    var blocs = $('#blocs-container').find('.blocForm');

    $.each(blocs, function (index, bloc) {
        var nomBloc = $(bloc).attr('id');
        if (blocsOuverts == 'true') {
            blocCollapse(nomBloc);
        }
        else {
            blocExpand(nomBloc);
        }
    });

    if (blocsOuverts == 'true') {

        blocsOuverts = 'false';
        bouton.html(htmlBouton);
        $('#iconeOuvrirFermerBlocs').removeClass('fa-angle-double-up').addClass('fa-angle-double-down');
        bouton.removeClass('btn-info').addClass('btn-success');

    } else {

        blocsOuverts = 'true';

        htmlBouton = htmlBouton.replace('Ouvrir blocs', 'Fermer blocs');
        bouton.html(htmlBouton);
        $('#iconeOuvrirFermerBlocs').removeClass('fa-angle-double-down').addClass('fa-angle-double-up');
        bouton.removeClass('btn-success').addClass('btn-info');

    }
    bouton.attr('blocs-ouverts', blocsOuverts);
}

function blocCollapsed(nomBloc) {
    return $("#" + nomBloc + " h4 > a").hasClass("collapsed");
}

function blocExpand(nomBloc) {
    $("#" + nomBloc + " h4 > a").filter(".collapsed").click();
}

function blocCollapse(nomBloc) {
    $("#" + nomBloc + " h4 > a").not(".collapsed").click();
}


function traiterValidation(form, jqXHR, erreurs) {
    var avertissements = {};
    if (erreurs !== undefined && erreurs instanceof Object && 'warning' in erreurs) {
        avertissements = erreurs['warning'];
        delete erreurs['warning'];
    }
    traiterErreurs(form, jqXHR, erreurs);
    traiterAvertissement(form, avertissements);
}

function traiterErreurs2(form, erreurs) {
    afficherValidation(form, erreurs, 'erreurs');
    tree_data['validations']['additionalParameters']['children']['erreurs'].name = 'Erreurs (' + nombreValidation('erreurs') + ')';
}

function traiterErreurs(form, jqXHR, erreurs) {
    if (jqXHR.status == 400) {
        afficherValidation(form, erreurs, 'erreurs');
        tree_data['validations']['additionalParameters']['children']['erreurs'].name = 'Erreurs (' + nombreValidation('erreurs') + ')';
    }
}

function traiterAvertissement(form, avertissements) {
    afficherValidation(form, avertissements, 'avertissements');
    tree_data['validations']['additionalParameters']['children']['avertissements'].name = 'Avertissements (' + nombreValidation('avertissements') + ')';
}

function effacerValidation(form) {
    if (typeof form !== 'undefined') {
        erreursAjax.effacerErreurChamps(form);
    }
    else {
        // erreurs
        tree_data['validations']['additionalParameters']['children']['erreurs']['additionalParameters']['children'] = {};
        tree_data['validations']['additionalParameters']['children']['erreurs'].name = 'Erreurs (0)';
        // avertissements
        tree_data['validations']['additionalParameters']['children']['avertissements']['additionalParameters']['children'] = {};
        tree_data['validations']['additionalParameters']['children']['avertissements'].name = 'Avertissements (0)';
    }
}

function calculerBloc07(idFormulaire, idBloc) {
    // calcul du bloc 7

    if ($('#mode-read-only').val() == 'False' && idBloc == '07') {
        var selector;

        if ([ID_FORMULAIRE.residentiel, ID_FORMULAIRE.multi, ID_FORMULAIRE.agricole].includes(idFormulaire)) {

            var aireTotaleAttiqueListe = ['aire_totale_attique', 'aire_finie_attique', 'aire_non_finie_attique'];

            function calculerAireTotaleAttique() {
                var aireTotaleAttique = (
                    Number($('input[name="' + aireTotaleAttiqueListe[1] + '"]').val()) +
                    Number($('input[name="' + aireTotaleAttiqueListe[2] + '"]').val())
                ).toFixed(1);
                $('input[name="' + aireTotaleAttiqueListe[0] + '"]').val(aireTotaleAttique);
            }

            selector = 'input[name="' + aireTotaleAttiqueListe[1] + '"], input[name="' + aireTotaleAttiqueListe[2] + '"]';
            $(selector).change(function () {
                calculerAireTotaleAttique();
            });

            calculerAireTotaleAttique();
        }

        if (idFormulaire == ID_FORMULAIRE.residentiel || idFormulaire == ID_FORMULAIRE.multi) {

            var aireTotaleSousSolListe = ['aire_totale_sous_sol', 'aire_finie_sous_sol', 'aire_non_finie_sous_sol', 'aire_garage_sous_sol', 'aire_logement_sous_sol'];
            var aireHabitableListe = ['aire_habitable', 'aire_etage', 'aire_mezzanine', 'aire_finie_attique', 'aire_garage'];

            function calculerAireTotaleSousSol() {
                var aireTotaleSousSol = (
                    Number($('input[name="' + aireTotaleSousSolListe[1] + '"]').val()) +
                    Number($('input[name="' + aireTotaleSousSolListe[2] + '"]').val()) +
                    Number($('input[name="' + aireTotaleSousSolListe[3] + '"]').val())
                ).toFixed(1);
                $('input[name="' + aireTotaleSousSolListe[0] + '"]').val(aireTotaleSousSol);
            }

            selector = 'input[name="' + aireTotaleSousSolListe[1] + '"], input[name="' + aireTotaleSousSolListe[2] + '"], input[name="' + aireTotaleSousSolListe[3] + '"]';
            $(selector).change(function () {
                calculerAireTotaleSousSol();
            });

            calculerAireTotaleSousSol();

            var b08NbChambreSousSol = $('#b08-renseignements-generaux-batiment').find('[name="nb_chambre_sous_sol"]');
            var b08NbChambreEtage = $('#b08-renseignements-generaux-batiment').find('[name="nb_chambre_etages"]');
            var b81LogementResidentiel = $('#b81-espace-locatif-residentiel').find('[name="etage"]');

            function calculerAireHabitable() {
                var aireHabitable = (
                    Number($('input[name="' + aireHabitableListe[1] + '"]').val()) +
                    Number($('input[name="' + aireHabitableListe[2] + '"]').val()) +
                    Number($('input[name="' + aireHabitableListe[3] + '"]').val()) -
                    Number($('input[name="' + aireHabitableListe[4] + '"]').val())
                ).toFixed(1);

                // si toutes les chambres sont situées au sous-sol sans aucune à l'étage, on doit ajouter l'aire finie sous-sol dans l'aire habitable.
                if (b08NbChambreSousSol.val() && b08NbChambreSousSol.val() != '0' && (!b08NbChambreEtage.val() || b08NbChambreEtage.val() == '0')) {
                    aireHabitable = (Number(aireHabitable) + Number($('input[name="' + aireTotaleSousSolListe[1] + '"]').val())).toFixed(1);
                }
                else {
                    // s'il existe au moins un logement au sous-sol au bloc 81 , alors nous additionnerons le champ 'aire_logement_sous_sol' dans l'aire habitable.
                    b81LogementResidentiel = $('#b81-espace-locatif-residentiel').find('[name="etage"]');
                    var b81LogementSousSol = b81LogementResidentiel.filter(function () {
                        return $(this).val() == 'SS';
                    });
                    // s'il y a des autres logements au bloc 08, alors nous additionnerons le champ 'aire_logement_sous_sol' dans l’aire habitable.
                    let b08AutresLogementsSupprimes = $('#b08-autre-logement').find('.sous-bloc-form .suppression-ligne, .sous-bloc-form .suppression-ligne-sauvegardee').closest('.sous-bloc-form');
                    let b08AutresLogements = $('#b08-autre-logement').find('.sous-bloc-form').not(b08AutresLogementsSupprimes).not('.nouvelle-ligne');
                    if (b81LogementSousSol.length || b08AutresLogements.length) {
                        aireHabitable = (Number(aireHabitable) + Number($('input[name="' + aireTotaleSousSolListe[4] + '"]').val())).toFixed(1);
                    }
                }
                // 9603, ET
                if (aireHabitable != 'NaN') {
                    if ($('input[name="' + aireHabitableListe[0] + '"]').val() !== aireHabitable) {
                        $('input[name="' + aireHabitableListe[0] + '"]').addClass('valeur-modifiee');
                    }
                    $('input[name="' + aireHabitableListe[0] + '"]').val(aireHabitable);
                }else{
                    $('input[name="' + aireHabitableListe[0] + '"]').val("");
                }

            }

            selector = 'input[name="' + aireHabitableListe[1] + '"], input[name="' + aireHabitableListe[2] + '"], input[name="' + aireHabitableListe[3] + '"], ' +
                'input[name="' + aireHabitableListe[4] + '"], input[name="' + aireTotaleSousSolListe[1] + '"], input[name="' + aireTotaleSousSolListe[4] + '"]';

            var b08ChampsAutresLogements = $('#b08-autre-logement').find('input[name="nb_chambre"], input[name="no_logement"], input.ctrl-suppression');
            setTimeout(function() {
                $(selector).add(b08NbChambreSousSol).add(b08NbChambreEtage).add(b81LogementResidentiel).add(b08ChampsAutresLogements).on('change', function () {

                    calculerAireHabitable();
                });
            }, 500);

            calculerAireHabitable();
        }

        if (idFormulaire == ID_FORMULAIRE.multi) {

            var aireLouableListe = ['aire_louable', 'aire_etage', 'aire_mezzanine', 'aire_finie_attique', 'aire_finie_sous_sol', 'aire_garage'];

            function calculerAireLouable() {
                var aireLouable = (
                    Number($('input[name="' + aireLouableListe[1] + '"]').val()) +
                    Number($('input[name="' + aireLouableListe[2] + '"]').val()) +
                    Number($('input[name="' + aireLouableListe[3] + '"]').val()) +
                    Number($('input[name="' + aireLouableListe[4] + '"]').val()) -
                    Number($('input[name="' + aireLouableListe[5] + '"]').val())
                ).toFixed(1);

                $('input[name="' + aireLouableListe[0] + '"]').val(aireLouable);
            }

            selector = 'input[name="' + aireLouableListe[1] + '"], input[name="' + aireLouableListe[2] + '"], ' +
                       'input[name="' + aireLouableListe[3] + '"], input[name="' + aireLouableListe[4] + '"], ' +
                       'input[name="' + aireLouableListe[5] + '"]';

            $(selector).change(function () {
                calculerAireLouable();
            });

            calculerAireLouable();
        }
    }
}

function interactionB07vsB31(idFormulaire, idBloc) {

    if (idFormulaire == ID_FORMULAIRE.nonResidentiel && idBloc == '07') {
        var modeReadOnly = $('#mode-read-only').val();
        if (modeReadOnly == 'False') {
            var b07HauteurBruteSousSol = $('#b07-dimension-base').find('[name="hauteur_brute_sous_sol"]');
            var b07HauteurHauteurEtage = $('#b07-dimension-base').find('[name="hauteur"]');
            var b31HauteurMoyenneSousSol = $('#b31-paroi-interieure-1').find('[name="hauteur_moyenne"]');
            var b31HauteurMoyenneEtage = $('#b31-paroi-interieure-2').find('[name="hauteur_moyenne"]');

            b07HauteurBruteSousSol.off('change').on('change', function () {
                changerB31HauteurSousSol($(this));
            });

            b07HauteurHauteurEtage.off('change').on('change', function () {
                changerB31HauteurEtage($(this));
            });

            changerB31HauteurSousSol(b07HauteurBruteSousSol);
            changerB31HauteurEtage(b07HauteurHauteurEtage);

            function changerB31HauteurSousSol(element) {
                if (element.val() != b31HauteurMoyenneSousSol.val()) {
                    b31HauteurMoyenneSousSol.val(element.val());
                    b31HauteurMoyenneSousSol.trigger('change');
                }
            }

            function changerB31HauteurEtage(element) {
                if (element.val() != b31HauteurMoyenneEtage.val()) {
                    b31HauteurMoyenneEtage.val(element.val());
                    b31HauteurMoyenneEtage.trigger('change');
                }
            }
        }
    }
}

function initServicesBloc81(idBloc) {
    if (idBloc == '81') {
        var modeReadOnly = $('#mode-read-only').val();
        if (modeReadOnly == 'False') {
            $('[name="service"]').off('change').on('change', function () {
                // mettre en ordre le nom des services
                var liSelect2Choices = $(this).parent().find('li.select2-search-choice').detach();
                var liOrdonnes = liSelect2Choices.sort(function (a, b) {
                    var contentA = $(a).find('div').text();
                    var contentB = $(b).find('div').text();
                    return (contentA < contentB) ? -1 : (contentA > contentB) ? 1 : 0;
                });
                $(this).parent().find('ul.select2-choices').prepend(liOrdonnes);
                appliquerChangement($(this));
            });

            // si le nombre de stationnements changent, ajouter/enlever le service en conséquence
            $('[name="nb_stationnement_interieur"], [name="nb_stationnement_exterieur"]').off('change').on('change', function () {
                var services = $(this).closest('.sous-bloc-form').find('[name="service"]');
                var valeurServices = services.val();
                var aucunStationnement = $(this).val() == 0;

                var serviceStationnement = '06';
                if ($(this).attr('name') == 'nb_stationnement_exterieur') {
                    serviceStationnement = '07';
                }

                if (aucunStationnement) {
                    // enlever le service de stationnement
                    if (valeurServices) {
                        var valeurServicesApres = $.grep(valeurServices, function (value) {
                            return value != serviceStationnement;
                        });
                        services.select2('val', valeurServicesApres, true);
                    }
                }
                else {
                    // ajouter le service de stationnement
                    if ($.inArray(serviceStationnement, valeurServices) == -1) {
                        if (!valeurServices) {
                            valeurServices = [];
                        }
                        valeurServices.push(serviceStationnement);
                        services.select2('val', valeurServices, true);
                    }
                }
                appliquerChangement($(this));
            });
        }
    }
}

function afficherFenetreChronologie() {

    var currentIdBatiment = $('#current-id-batiment').val();
    var currentDateEvenement = $('#date-evenement').val();

    var url = "/gestion-roles/editeur-fiche/chronologie/id-batiment/" + currentIdBatiment + "/date/" + encodeURI(currentDateEvenement) + "/";

    var variableModalChronologie = {
        id: "modal-chronologie",
        view: "/core/modal/",
        id_processus: "",
        titre: "Chronologie des évènements",
        titre_supp: "",
        module: "",
        contenuHTML: "",
        template: "",
        template_view: url,
        template_depart: "",
        template_depart_view: "",
        url: "",
        taille: "immense",
        resultat: "",
        resultat_depart: "",
        wizard: false,
        callback: function () {
            InitTable('chronologie-travaux', 3, []);
            InitTable('chronologie-mutations', 6, []);
            InitTable('chronologie-permis', 7, []);

        },
        boutons: [
            {
                type: "cancel",
                label: "Annuler",
                title: "",
                classSupp: "",
                afficher: true
            }
        ]
    };

    fenetreModal.creerModal(variableModalChronologie, {});
}

function chargerFormTableauBlanc(type, avecTableauExistant) {
    wait.start();

    var modeReadOnly = $('#mode-read-only').val() != "False";
    if (!navigator.onLine) {
        wait.stop();

        if ($("#modal_tableau_blanc").length) {
            $("#modal_tableau_blanc_container").empty();
        }

        $(".modal-tb-title.croquis").toggleClass("hidden", type !== "croquis");
        $(".modal-tb-title.note").toggleClass("hidden", type !== "note");
        $("#formulaire_tableau_blanc_mode_deconnecte").data("type-tableau", type);

        setTimeout(function () {
            if (avecTableauExistant) {
                var messageToast = "Les notes "
                if (type === "croquis") {
                    messageToast += "sur croquis";
                } else {
                    messageToast += "sur tableau blanc";
                }
                messageToast += " déjà prises sur cet évènement ne peuvent êtres consultées puisque vous êtes hors ligne."
                infos.ajouterMessageToast({
                    message: messageToast,
                    messageDuree: 10000,
                    icone: 'fa-exclamation-triangle',
                    iconeCouleur: 'orange'
                });
            }

            if (!modeReadOnly) {
                $('#modal_tableau_blanc_mode_deconnecte').modal({
                    show: true,
                    backdrop: 'static'
                });
            }
        }, 0);

        if (!modeReadOnly) {
            setTimeout(function () {
                $(".print-animated .print-animated-content").addClass('visible');

                initTableauBlanc("canvas_tableau_blanc_mode_deconnecte", "formulaire_tableau_blanc_mode_deconnecte", "canvas_tableau_blanc_container_mode_deconnecte");
            }, 500);
        }
    } else {
        var idEvenement = $("#id-evenement").val();
        var idBatiment = $("#current-id-batiment").val();
        var tableauxFiltres = [];

        if (window.isRunningInApp) {
            window.getTableauxBlancsByFiche(parseInt(idBatiment), idEvenement, type)
                .then(function (tableauxIndexedDB) {
                    tableauxFiltres = tableauxIndexedDB
                        .filter(function (tb) {
                            return !tb.isDeleted && tb.typeTableau === type;
                        })
                        .map(function (tb) {
                            return {
                                pk: tb.idTableau || 0,
                                url: tb.svgContent ? 'data:image/svg+xml;base64,' + btoa(tb.svgContent) : null,
                                localId: tb.id
                            };
                        });

                    $("#canvas-saved-img").remove();
                    $("#canvas-croquis-img").remove();
                    if (!$('#json_liste_tableaux').length) {
                        $('#formulaire_tableau_blanc').append(
                            '<script id="json_liste_tableaux" type="application/json">' + JSON.stringify(tableauxFiltres) + '</script>'
                        );
                    } else {
                        $('#json_liste_tableaux').text(JSON.stringify(tableauxFiltres));
                    }

                    $(".modal-tb-title.croquis").toggleClass("hidden", type !== "croquis");
                    $(".modal-tb-title.note").toggleClass("hidden", type !== "note");
                    $("#formulaire_tableau_blanc").data("type-tableau", type);

                    var nbTableaux = tableauxFiltres.length || 1;
                    $("#tableau_blanc_nb").text(nbTableaux);
                    $("#tableau_blanc_nb").data("nb-tableaux", nbTableaux);

                    if (nbTableaux <= 1) {
                        $(".tb-pagination-changer-index[data-direction='previous']").prop('disabled', true);
                        $(".tb-pagination-changer-index[data-direction='next']").prop('disabled', true);
                    } else {
                        $(".tb-pagination-changer-index[data-direction='previous']").prop('disabled', true);
                        $(".tb-pagination-changer-index[data-direction='next']").prop('disabled', false);
                    }

                    $("#tableau_blanc_index").text(1);

                    wait.stop();
                    setTimeout(function () {
                        $('#modal_tableau_blanc').modal({
                            show: true,
                            backdrop: 'static'
                        });
                    }, 0);

                    if (type === "croquis" && !$("#canvas-croquis-img").length) {
                        var croquisSrc = $("#b06-croquis-batiment .ace-thumbnails #photo-principale").attr("src");
                        if (croquisSrc) {
                            $("#canvas_tableau_blanc_container").append(
                                '<img id="canvas-croquis-img" src="' + croquisSrc + '" class="hidden" alt="Croquis principal">'
                            );
                        }
                    }

                    setTimeout(function () {
                        $(".print-animated .print-animated-content").addClass('visible');
                        if (modeReadOnly) {
                            initTableauBlancReadOnly();
                        } else {
                            initTableauBlanc("canvas_tableau_blanc", "formulaire_tableau_blanc", "canvas_tableau_blanc_container");
                            if (tableauxFiltres.length > 0 && tableauxFiltres[0].url) {
                                setTimeout(function () {
                                    tbScope.project.activeLayer.removeChildren();
                                    tbScope.project.importSVG(tableauxFiltres[0].url, function () {
                                        tbTopLayer.position = tbScope.view.center;
                                        var scale = getItemSizeToFitInCanvas(tbTopLayer);
                                        tbTopLayer.scale(scale, scale);
                                    });

                                    $("#formulaire_tableau_blanc").data("id-tableau", tableauxFiltres[0].pk);
                                    $("#formulaire_tableau_blanc").data("local-id", tableauxFiltres[0].localId);
                                }, 100);
                            }
                        }
                    }, 500);
                })
                .catch(function (error) {
                    console.error("❌ Erreur chargement tableaux depuis IndexedDB:", error);
                    wait.stop();
                });
        } else {
            var url = "/gestion-roles/editeur-fiche/evenement/" + idEvenement + "/type/" + type + "/tableau-blanc/0/";
            if (idBatiment && estBatiment($('#current-id-formulaire').val())) {
                url = url + "batiment/" + idBatiment + "/";
            }

            var success = function (response) {
                $('#modal_tableau_blanc_container').html(response);

                wait.stop();

                setTimeout(function () {
                    $('#modal_tableau_blanc').modal({
                        show: true,
                        backdrop: 'static'
                    });
                }, 0);

                setTimeout(function () {
                    $(".print-animated .print-animated-content").addClass('visible');
                    if (modeReadOnly) {
                        initTableauBlancReadOnly();
                    } else {
                        initTableauBlanc("canvas_tableau_blanc", "formulaire_tableau_blanc", "canvas_tableau_blanc_container");
                    }
                }, 500);
            };

            var erreur = function (jqXHR, textStatus, errorThrown) {
                wait.stop();

                var messageErreur = "Erreur lors de l'ouverture du tableau blanc.";

                if (typeof jqXHR.responseJSON !== 'undefined' && typeof jqXHR.responseJSON.message_erreur !== 'undefined') {
                    messageErreur = jqXHR.responseJSON.message_erreur;
                } else if (type == 'croquis') {
                    messageErreur = "Erreur lors de l'ouverture des notes sur croquis.";
                }

                infos.ajouterMessageToast({
                    message: messageErreur,
                    messageDuree: 3000,
                    messageCouleur: 'red'
                });
            };

            call_ajax(url, "GET", undefined, success, erreur);
        }

    }
}

function chargerModalSignatureB79(idB79Instance, noLigne, signature) {
    wait.start();

    if(window.isRunningInApp) {
        wait.stop();

        if($("#modal_signature_b79").length) {
            $("#modal_signature_b79_container").empty();
        }

        $(".b79-date-signature").val(moment().format('YYYY-MM-DD HH:mm'));
        $("#btn_sauvegarde_signature_mode_deconnecte").data("id-b79-instance", idB79Instance);
        $("#btn_sauvegarde_signature_mode_deconnecte").data("no-ligne", noLigne);

        setTimeout(function () {
            $('#modal_signature_b79_mode_deconnecte').modal({
                show: true,
                backdrop: 'static'
            });
        }, 0);

        setTimeout(function () {
            $(".print-animated .print-animated-content").addClass('visible');

            initTableauBlanc("canvas_signature_mode_deconnecte", "formulaire_signature_mode_deconnecte", "canvas_signature_container_mode_deconnecte");
        }, 500);
        $("#canvas-croquis-img").remove();
    } else {
        var id_evenement = $("#id-evenement").val();
        var url = "/gestion-roles/editeur-fiche/evenement/" + id_evenement  + "/signature-b79/";
        if(idB79Instance != "" && idB79Instance != "None") {
            url = url + "instance/" + idB79Instance + "/";
        }

        var succes = function (response) {
            $('#modal_signature_b79_container').html(response);

            wait.stop();

            setTimeout(function () {
                $('#modal_signature_b79').modal({
                    show: true,
                    backdrop: 'static'
                });
            }, 0);

            setTimeout(function () {
                $(".print-animated .print-animated-content").addClass('visible');
                initTableauBlanc("canvas_signature", "formulaire_signature", "canvas_signature_container");
            }, 500);
        };

        var erreur = function () {
            wait.stop();

            infos.ajouterMessageToast({
                message: "Une erreur s'est produite lors de l'ouverture du modal de la signature. Si l'erreur persiste, veuillez contacter un administrateur.",
                messageDuree: 1500,
                messageCouleur: 'red'
            });
        };

        var params = {
            "noLigne": noLigne,
            "signature": signature
        };

        call_ajax(url, "GET", params, succes, erreur);
    }
}

function modalTableauBatiment(idUe, idEvenement) {

    var table = $('#modal-table-batiment');

    table.DataTable({
        'serverSide': true,
        "scrollX": true,
        "searching": true,
        "aaSorting": [], // DÉFINITION DU TRI PAR DÉFAUT À L'OUVERTURE
        "bFilter": false,
        "bInfo": false,
        "bLengthChange": false,
        "language": {
            "url": datatable_locale_url
        },
        "pageLength": 10,
        "scrollY": "400px",
        "scrollCollapse": true,
        "ajax": {
            //origine permet d'identifier ou se situe le tableau, car le bouton agit autrement
            "url": `/gestion-roles/exp-ue/json-batiment/unite-evaluation/${idUe}/origine/2/id-evenement/${idEvenement}/`,
            "data": function (d) {
                d.columns = [];
            }
        },
        async: false,
        "columnDefs": [
            {"title": "Photo", "targets": 0, "width": "128px", "orderable": false},
            {"title": "No bâtiment", "targets": 1},
            {"title": "ID bâtiment", "targets": 2},
            {"title": "Principal", "targets": 3},
            {"title": "Type", "targets": 4},
            {"title": "Court descriptif", "targets": 5},
            {"title": "Valeur méthode coût", "targets": 6},
            {"title": "Date Début", "targets": 7},
            {"title": "Date Fin", "targets": 8},
            {"title": "", "targets": 9, "orderable": false},
        ],

        "preDrawCallback": function () {
            wait.start();
            return true;
        },
        "drawCallback": function () {
            wait.stop();

            var expUeBatimentPhotoPrincipale = $('#exp-ue-batiment-photo-principale');
            ajusterTailleImage(expUeBatimentPhotoPrincipale.find('img'), '100px', '80px');
            initAceThumbnails('colorbox-photo-principale');

            // permet de mettre la ligne en jaune lorsque la date de fin est est différent de null, étrange comportement du j, remplacé par un variable t
            $('#modal-table-batiment').find('tr').each(function (i, row) {
                row = $(row);
                var t = 0;
                $(row).find('td').each(function (j, col) {
                    col = $(col);
                    if (t == 8) {
                        if ($(col).text() != '\n\n\n') {
                            $(row).css("background-color", "#B0BED9");
                        }
                    }
                    t++;
                });
            });
        }
    });
    table.on('processing.dt', function (e, settings, processing) {
        if (processing) {
            wait.start();
        } else {
            wait.stop();
        }
    });


    var dateEvenement = $('#date-evenement').val();
    idEvenement = $('#id-evenement').val();

    $(document.body).on('click', '.batiment-tableau', function () {
        var idBatiment = $(this).attr('id-batiment');
        var idTypeBatiment = $(this).attr('id-type-batiment');
        var noBatiment = $(this).attr('no-batiment'); //obtiens le numéro de batiment attribué automatiquement
        var idFormulaire = $(this).attr('id-formulaire');
        var titreFiche = getTitre(idFormulaire);
        var descriptif = $(this).attr('descriptif');

        initOuvrirFiche(idBatiment, idTypeBatiment, titreFiche, idEvenement, dateEvenement, idFormulaire);

        $('#current-id-formulaire').val(idFormulaire);
        $('#current-id-batiment').val(idBatiment);
        $('#current-no-batiment').val(noBatiment); //stock la no batiment de la fiche de batiment sélectionnés
        $('#current-id-type-batiment').val(idTypeBatiment);
        $('#current-descriptif').val(descriptif);

        $('.close-modal-sel-fiche').off('click');
        $('#btn-close-modal-sel-fiche').trigger('click');
        $('.close-modal-sel-fiche').on('click');

    });

}


// Permet la fermeture de l'onglet du fureteur, si pas de fiche sélectionnée
$('.close-modal-sel-fiche').on('click', function () {

    if ($('#07-actions').length == 0) {
        window.top.close();
    }
});

$('.editeur-fiche').on('change', '#modal-changer-type-fiche [name="id_type_batiment"]', function () {
    $('.save-changer-type-fiche').attr('disabled', false);
});

$('.editeur-fiche').on('click', '.save-changer-type-fiche', function () {
    var idBatiment = $('#current-id-batiment').val();
    var idEvenement = $('#id-evenement').val();
    var idUe = $('#id-ue').val();
    var idTypeBatiment = $('#modal-changer-type-fiche [name="id_type_batiment"]').val();

    wait.start();

    var params = {
        id_evenement: idEvenement,
        id_batiment: idBatiment,
        id_type_batiment: idTypeBatiment
    };
    let url = $(this).data('url');
    let success_cb = function(resp) {
        $('#current-id-formulaire').val('None');
        ouvrirUrlEvenement(idEvenement);
    };
    call_ajax(url, 'POST', params, success_cb);
});


function updateTotaux81() {
    var containerRowsR = $('#b81-espace-locatif-residentiel').find('.sous-bloc-form:not(.nouvelle-ligne)').filter(filtrerLigneSuppression);
    var total_nb_espace = containerRowsR.length;
    var total_nb_piece = 0;
    var total_loyer_mensuel = 0;
    var total_nb_stationnement_interieur = 0;
    var total_nb_stationnement_exterieur = 0;

    containerRowsR.each(function () {
        var nb_piece = $(this).find('[name="nb_piece"]');
        var loyer_mensuel = $(this).find('[name="loyer_mensuel"]');
        var nb_stationnement_interieur = $(this).find('[name="nb_stationnement_interieur"]');
        var nb_stationnement_exterieur = $(this).find('[name="nb_stationnement_exterieur"]');

        total_nb_piece += TryParseInt(nb_piece.val(), 0);
        total_loyer_mensuel += TryParseFloat(loyer_mensuel.val(), 0);
        total_nb_stationnement_interieur += TryParseInt(nb_stationnement_interieur.val(), 0);
        total_nb_stationnement_exterieur += TryParseInt(nb_stationnement_exterieur.val(), 0);
    });

    var containerRowsNR = $('#b81-espace-locatif-nonresidentiel').find('.sous-bloc-form:not(.nouvelle-ligne)').filter(filtrerLigneSuppression);
    var total_nb_espace_nr = containerRowsNR.length;
    var total_surface_locative_brute = 0;
    var total_loyer_annuel_bail = 0;
    var total_loyer_annuel_additionnel = 0;

    containerRowsNR.each(function () {
        var surface_locative_brute = $(this).find('[name="aire_m2"]');
        var loyer_annuel_bail = $(this).find('[name="mnt_loyer_base"]');
        var loyer_annuel_additionnel = $(this).find('[name="mnt_loyer_additionnel"]');

        total_surface_locative_brute += TryParseFloat(surface_locative_brute.val(), 0);
        total_loyer_annuel_bail += TryParseFloat(loyer_annuel_bail.val(), 0);
        total_loyer_annuel_additionnel += TryParseFloat(loyer_annuel_additionnel.val(), 0);
     });

    var b81Container = $('#b81-inventaire');
    b81Container.find('[name="total_nb_espace"]').val(total_nb_espace);
    b81Container.find('[name="total_nb_piece"]').val(total_nb_piece);
    b81Container.find('[name="total_loyer_mensuel"]').val(total_loyer_mensuel.toString() + ' $');
    b81Container.find('[name="total_nb_stationnement_interieur"]').val(total_nb_stationnement_interieur);
    b81Container.find('[name="total_nb_stationnement_exterieur"]').val(total_nb_stationnement_exterieur);

    // Espaces locatifs non résidentiels
    b81Container.find('[name="total_nb_espace_nr"]').val(total_nb_espace_nr);
    b81Container.find('[name="total_surface_locative_brute"]').val(total_surface_locative_brute.toFixed(2));
    b81Container.find('[name="total_loyer_annuel_bail"]').val(total_loyer_annuel_bail.toString() + ' $');
    b81Container.find('[name="total_loyer_annuel_additionnel"]').val(total_loyer_annuel_additionnel.toString() + ' $');
}

function updateNumeros63() {
    var b63Container = $('#b63-dependance-detachee');
    var inputs = b63Container.find("[name='numero']");

    inputs.each(function () {
        var texte = $.trim($(this).val());
        if (texte.length == 1) {
            $(this).val('0' + texte);
        }
    });
}

function updateTotauxAutresSources() {
    var nombre = $('[id$=-autres-sources] [name=nombre]');
    var cout_unitaire = $('[id$=-autres-sources] [name=cout_unitaire]');
    function updaterTotal(inputChanged) {
        var ligne = inputChanged.closest('.sous-bloc-form');
        if (ligne.hasClass('nouvelle-ligne')) {
            return;
        }
        nombre = ligne.find('[name=nombre]');
        cout_unitaire = ligne.find('[name=cout_unitaire]');
        var cout_total = ligne.find('[name=cout_total]');
        cout_total.val((TryParseFloat(nombre.val(), 0) * TryParseFloat(cout_unitaire.val(), 0)).toFixed(2));
    }
    var fonctionUpdateTotal = function () {
        updaterTotal($(this));
    };
    nombre.each(function () {
        if ($(this).data('nombre_update') != null) {
            $(this).off('change', $(this).data('nombre_update'));
        }
    });
    nombre.change(fonctionUpdateTotal);
    nombre.data('nombre_update', fonctionUpdateTotal);

    cout_unitaire.each(function () {
        if ($(this).data('cout_unitaire_update') != null) {
            $(this).off('change', $(this).data('cout_unitaire_update'));
        }
    });
    cout_unitaire.change(fonctionUpdateTotal);
    cout_unitaire.data('cout_unitaire_update', fonctionUpdateTotal);
}


/**
 * Initialisation du Zoom sur les sections de la fiche qui contiennent des slimscroll. On lance aussi le recalcul à chaque ajout de ligne pour le dit bloc.
 */
function initZoomContenuSlimscroll() {
//    On initialise le contrôle.
//    Recalcul à l'ajout d'un élément dans le bloc.
//    On ajoute un icône de gestion du zoom au dessus de la section à slimscroller.

    var listeBlocsZoom = reqZoomSections();

    $.each(listeBlocsZoom, function (index, value) {
        $(value).before('<div class="champs-multiple-header row-padding-5"></div>');
        $(value).addClass('modal-zoom-ouvrir fiche row-padding-5');
        ajouterBoutonZoomSection(value);
    });
}


function reqZoomSections() {
    var params = {'id_formulaire': $('#current-id-formulaire').val()};
    var reponse = [];

    var jqxhr = $.ajax({
        url: '/gestion-roles/editeur-fiche/liste-blocs-zoom/',
        data: params,
        type: 'GET',
        dataType: 'html',
        async: false
    });
    jqxhr
        .done(function (response) {
            reponse = JSON.parse(response);
        });
    jqxhr
        .fail(function (jqxhr, textStatus, errorThrown) {
            infos.ajouterMessageToast({
                message: errorThrown,
                messageDuree: 5000,
                messageCouleur: "red"
            });
        });

    return reponse.blocs;
}

function ajouterBoutonZoomSection(blocContenu) {

    // On insère deux boutons (Un à gauche et l'autre à droite)

    var idZoom = 'zoom-' + blocContenu.replace('#', '');

    for (var i = 1; i < 3; i++) {
        var idZoomBoucle = idZoom + '-' + i;
        var bouton = '<button id="' + idZoomBoucle + '" type="button" name="' + blocContenu + '" class="btn btn-sm btn-info zoom-contenu-bouton" data-modal-titre="Zoom sur ce contenu"><i class="ace-icon fa fa-arrows-alt"></i><span class=""> Zoom sur ce contenu </span></button>';
        $(blocContenu).siblings('.champs-multiple-header').append(bouton);
        initBoutonZoom(idZoomBoucle, blocContenu);
    }
}

function initBoutonZoom(idZoom, blocContenu) {
    $('#' + idZoom).off('click').on('click', function () {
        POSITION_SCROLLBAR = $(window).scrollTop();
        zoomContenuSlimscroll(blocContenu);
    });
}


function fermetureZoomContenuSlimscroll(modal) {
    var blocContenu = '#' + $(modal).find('.zoom').attr('id');
    deZoomContenuSlimscroll(blocContenu);
    $(window).scrollTop(POSITION_SCROLLBAR);
    POSITION_SCROLLBAR = 0;
    // On reset aussi la hauteur du scroball pour la fiche, indépendamment de la hauteur que nous avions dans le modal-zoom.


}


/**
 * Zoom sur le contenu d'un bloc de la fiche qui contient un slimscroll.
 * @param {array} blocselection - Sélection jQuery de la section du bloc qui contient un slimscroll
 * @return {string} batimentFormulaire - Rendu html du formulaire de bâtiment pour l'ajout de travaux.
 */
function zoomContenuSlimscroll(blocContenu) {
    //    On isole le bloc
    $(blocContenu).addClass('zoom');

    // On gèle le scroll de la page
    $('html, body').css({
        'overflow': 'hidden',
        'height': '100%'
    });

    // On simule un modal
    var titreZoom = $(blocContenu).closest('form').find('.panel-heading > h4.titre-bloc').text().trim();

    var zoomModalEntete = '<div id="modal-zoom" class="modal in zoom" style="z-index: 9000; display: block;"><div class="modal-dialog modal-zoom" style="display: block;"><div class="modal-content"><div data-etape_depart="" data-type="" data-mode="" class="modal-header"><button type="button" class="close" data-dismiss="modal-fermer" aria-label="Close"><span aria-hidden="true">×</span></button><h4 class="modal-title text-center text-primary">' + titreZoom + '</h4></div><div id="contenu"><div class="modal-body"><div class="contenu-zoom"></div></div></div></div></div></div></div>';

    // On affiche le faux modal avec une animation
    $(zoomModalEntete).insertBefore(blocContenu);
    $(blocContenu).parent().addClass('dezoom');
    var contenuZoom = $(blocContenu).detach();
    contenuZoom.appendTo("div.contenu-zoom");

    // On ajoute une copie du bouton "importer plusieurs fichiers" dans le modal.
    $('#btn-select-fichiers-fiche').clone(true).prependTo('#modal-zoom .modal-header');



    //    On affiche le modal-backdrop
    $('<div class="modal-backdrop"></div>').appendTo(document.body);

    //    On valide la hauteur du contenu du modal pour ajuster le formulaire à la bonne taille de la fenêtre modal-zoom
    var hauteurModalContentZoom = $('#modal-zoom').find('.modal-content').height() - 130;

    ajouterSlimScrollEF($(blocContenu), hauteurModalContentZoom, true);
    var $containerSousBloc = $(blocContenu).find('.container-sous-bloc-form.gestion-scroll');
    $containerSousBloc.css('height', hauteurModalContentZoom);

    initBoutonsModalZoom();
}


function initBoutonsModalZoom() {
    $('#modal-zoom .close').off('click').on('click', function () {
        fermetureZoomContenuSlimscroll('#modal-zoom');
    });
}


/**
 * À la "fermeture" du modal, on rétabli le zoom du bloc, désactive le modal-backdrop, et détruit l'entête du "modal".
 * @param {array} blocselection - Sélection jQuery de la section du bloc qui contient un slimscroll
 * @return {string} batimentFormulaire - Rendu html du formulaire de bâtiment pour l'ajout de travaux
 */
function deZoomContenuSlimscroll(blocContenu) {
//    On rétabli le scrol de la page
    $(blocContenu).removeClass('zoom');
    $('html, body').css({
        overflow: 'auto',
        height: 'auto'
    });

    $(".modal-backdrop").remove();
    var contenuContenant = $(blocContenu).closest('form.blocForm').find(".dezoom");
    var contenuZoom = $(blocContenu).detach();
    contenuZoom.appendTo(contenuContenant);
    $('#modal-zoom').remove();

    //    On valide la hauteur du contenu du modal pour restaurer le container du sous-bloc à sa taille d'origine
    var $containerSousBloc = $(blocContenu).find('.container-sous-bloc-form.gestion-scroll');
    var hauteurOriginalecontainerSousBloc = $(blocContenu).attr('hauteur-originale');
    $containerSousBloc.css('height', hauteurOriginalecontainerSousBloc + 'px');

}


function lierAiresPourcentages() {
    lierAirePourcentage('b12-porte', 'aire_type', 'pourcentage', ['aire_mur_exterieur_sous_sol'], true, 1, 1, 'nombre', true);
    lierAirePourcentage('b12-fenetre', 'aire_type', 'pourcentage', ['aire_mur_exterieur_sous_sol'], true, 1, 1, 'nombre', true);
    // DM: il faut hardcoder ici les champs à lier
    lierAirePourcentage('b22-bati-mur', 'aire', 'pourcentage', ['aire_mur_exterieur_etage'], true, 1, 0);
    lierAirePourcentage('b22-materiau-parement', 'aire', 'pourcentage', ['aire_mur_exterieur_etage']);
    // CV: 8117, changer le nombre change aussi le pourcentage, le pourcentage est en lecture seule si nombre ou aire.

    // #31810 : pour b22 porte et fenetre: création d'un champ composite d'aire entresol (b07 entresol: hauteur * perimetre)
    // pour permettre de calculer correctement le pourcentage d'aire de ces composantes via lierAirePourcentage
    let $b07 = $('#b07-dimension-base');
    var $champ_fictif_aire_entresol = $b07.find('[name="champ_fictif_aire_entresol"]');
    if ($champ_fictif_aire_entresol.length === 0) {
        $champ_fictif_aire_entresol = $('<input type="hidden" name="champ_fictif_aire_entresol">').appendTo($b07);
    }
    var updateAireEntreSol = function (eventupdateAireEntreSol) {
        let perimetre = TryParseFloat($('[name=perimetre_entresol]').val(), 0) || 0;
        let hauteur = TryParseFloat($('[name=hauteur_entresol]').val(), 0) || 0;
        // conserver une ref du champ a l'origine du changement, pour faire le rollback de valeur si nécessaire
        if(eventupdateAireEntreSol){
            let champ_origine = $(eventupdateAireEntreSol.currentTarget);
            if(champ_origine){
                $champ_fictif_aire_entresol.data('champ_lier_aire_pourcentage_origine', champ_origine);
            }
        }
        $champ_fictif_aire_entresol.val(perimetre * hauteur).change();
    };
    $('[name=perimetre_entresol]').data('val', $('[name=perimetre_entresol]').val());
    $('[name=hauteur_entresol]').data('val', $('[name=hauteur_entresol]').val());
    $('[name=perimetre_entresol], [name=hauteur_entresol]').off('change.updateAireEntreSol').on('change.updateAireEntreSol', updateAireEntreSol);
    updateAireEntreSol();
    $champ_fictif_aire_entresol.data('val', $champ_fictif_aire_entresol.val());

    lierAirePourcentage('b22-porte', 'aire_type', 'pourcentage', ['aire_mur_exterieur_etage', 'champ_fictif_aire_entresol'], true, 1, 1, 'nombre', true);
    lierAirePourcentage('b22-fenetre', 'aire_type', 'pourcentage', ['aire_mur_exterieur_etage', 'champ_fictif_aire_entresol'], true, 1, 1, 'nombre', true);
    // CV: équivalent de 8117 pour bloc 31.
    lierAirePourcentageArrow(
        "pourcentage_update_porte",
        () => $('#b31-porte').find('[name="pourcentage"]'),
        1,
        () => $('#b31-porte').find('[name="aire_type"]'),
        () => $('#b31-porte').find('[name="nombre"]'),
        [
            () => $('#b07-dimension-base').find('[name="aire_totale_sous_sol"]'),
            () => $('#b07-dimension-base').find('[name="aire_mezzanine_sous_sol"]'),
            () => $('#b07-dimension-base').find('[name="aire_totale_vide_sanitaire"]'),
            () => $('#b07-dimension-base').find('[name="aire_etage"]'),
            () => $('#b07-dimension-base').find('[name="aire_mezzanine"]'),
            () => $('#b07-dimension-base').find('[name="aire_totale_attique"]')
        ],
        [
            () => $('#b31-dimension-cloison').find('[name="densite"]'),
            () => $('#b31-dimension-cloison').find('[name="hauteur_moyenne"]'),
            () => $('#b31-dimension-cloison').find('[name="pourcentage"]')
        ],
        (aireTotale, fonctionGetConnexes) => {
            var champsDensite = fonctionGetConnexes[0]();
            var champsHauteur = fonctionGetConnexes[1]();
            var champsPourcentage = fonctionGetConnexes[2]();
            var aire_cloisons = 0;
            // Il s'agit du même bloc, donc on a le même nombre de ligne
            for (var i = 0; i < champsDensite.length; i++) {
                var densite = TryParseFloat($(champsDensite[i]).val(), 0);
                var hauteur_moyenne = TryParseFloat($(champsHauteur[i]).val(), 0);
                var pourcentage = TryParseFloat($(champsPourcentage[i]).val(), 0) * 0.01;
                aire_cloisons += round(aireTotale / 500.0 * densite * hauteur_moyenne * pourcentage, 1);
            }
            return aire_cloisons;
        });
    lierAirePourcentageArrow(
        "pourcentage_update_fenetre",
        () => $('#b31-fenetre').find('[name="pourcentage"]'),
        1,
        () => $('#b31-fenetre').find('[name="aire_type"]'),
        () => $('#b31-fenetre').find('[name="nombre"]'),
        [
            () => $('#b07-dimension-base').find('[name="aire_totale_sous_sol"]'),
            () => $('#b07-dimension-base').find('[name="aire_mezzanine_sous_sol"]'),
            () => $('#b07-dimension-base').find('[name="aire_totale_vide_sanitaire"]'),
            () => $('#b07-dimension-base').find('[name="aire_etage"]'),
            () => $('#b07-dimension-base').find('[name="aire_mezzanine"]'),
            () => $('#b07-dimension-base').find('[name="aire_totale_attique"]')
        ],
        [
            () => $('#b31-dimension-cloison').find('[name="densite"]'),
            () => $('#b31-dimension-cloison').find('[name="hauteur_moyenne"]'),
            () => $('#b31-dimension-cloison').find('[name="pourcentage"]')
        ],
        (aireTotale, fonctionGetConnexes) => {
            var champsDensite = fonctionGetConnexes[0]();
            var champsHauteur = fonctionGetConnexes[1]();
            var champsPourcentage = fonctionGetConnexes[2]();
            var aire_cloisons = 0;
            // Il s'agit du même bloc, donc on a le même nombre de ligne
            for (var i = 0; i < champsDensite.length; i++) {
                var densite = TryParseFloat($(champsDensite[i]).val(), 0);
                var hauteur_moyenne = TryParseFloat($(champsHauteur[i]).val(), 0);
                var pourcentage = TryParseFloat($(champsPourcentage[i]).val(), 0) * 0.01;
                aire_cloisons += round(aireTotale / 500.0 * densite * hauteur_moyenne * pourcentage, 1);
            }
            return aire_cloisons;
        });
    // fiche terrain: meme principe que ceux du NR
    lierAirePourcentage('b04-topographie', 'superficie', 'pourcentage', ['superficie'], true, 2, 2);
}

function round(value, precision) {
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
}

function lierAirePourcentageArrow(nom, fonctionGetPourcentage, precisionPourcentage, fonctionGetAire, fonctionGetNombre,
                                  fonctionGetAireTotales, fonctionGetConnexes, fonctionAireConnexe) {

    fonctionGetConnexes = typeof fonctionGetConnexes !== 'undefined' ? fonctionGetConnexes : {};

    var champPourcentage = fonctionGetPourcentage();
    var champAire = fonctionGetAire();
    var champNombre = null;
    if (typeof fonctionGetNombre !== 'undefined') {
        champNombre = fonctionGetNombre();
    }

    function fonctionUpdate() {
        var champPourcentage = fonctionGetPourcentage();
        var champAire = fonctionGetAire();
        var champNombre = null;
        if (typeof fonctionGetNombre !== 'undefined') {
            champNombre = fonctionGetNombre();
        }
        var aireTotale = 0;
        for (var i = 0; i < fonctionGetAireTotales.length; i++) {
            var champ = fonctionGetAireTotales[i]();
            if (champ.length > 0)
                aireTotale += TryParseFloat(champ.val(), 0);
        }
        if (aireTotale == 0) {
            for (let i = 0; i < champPourcentage.length; i++) {
                $(champPourcentage[i]).prop('readonly', false);
            }
            return;
        }
        for (let i = 0; i < champAire.length; i++) {
            var aire = TryParseFloat($(champAire[i]).val(), 0);
            var nombre;
            if (champNombre !== null) {
                nombre = TryParseInt($(champNombre[i]).val(), 0);
            } else {
                nombre = 0;
            }
            var aireConnexe;
            if (typeof fonctionAireConnexe !== 'undefined')
                aireConnexe = fonctionAireConnexe(aireTotale, fonctionGetConnexes);
            if (aireConnexe == 0) {
                $(champPourcentage[i]).val(null);
                return;
            }
            var pourcentage = round(aire * nombre * 100 / aireConnexe, precisionPourcentage);
            if (pourcentage > 0)
                $(champPourcentage[i]).val(pourcentage);
            else
                $(champPourcentage[i]).val(null);
            if ($(champNombre[i]) !== null && $(champNombre[i]).val() == '' &&
                $(champAire[i]) !== null && $(champAire[i]).val() == '') {
                $(champPourcentage[i]).prop('readonly', false);
            } else {
                $(champPourcentage[i]).prop('readonly', true);
            }
        }
    }

    if (champAire.data(nom) != null) {
        champAire.off('change', champAire.data(nom));
    }
    champAire.change(fonctionUpdate);
    champAire.data(nom, fonctionUpdate);
    if (champNombre !== null) {
        if (champNombre.data(nom) != null) {
            champNombre.off('change', champNombre.data(nom));
        }
        champNombre.change(fonctionUpdate);
        champNombre.data(nom, fonctionUpdate);
    }

    var fonctions = fonctionGetAireTotales.concat(fonctionGetConnexes);
    for (var i = 0; i < fonctions.length; i++) {
        var champ = fonctions[i]();
        if (champ.data(nom) != null) {
            champ.off('change', champ.data(nom));
        }
        champ.change(fonctionUpdate);
        champ.data(nom, fonctionUpdate);
    }
}

function lierAirePourcentage(nomSousBloc, nomChampAire, nomChampPourcentage, champsAireTotale, ajouterListe,
                             precisionChampAire, precisionChampPourcentage, nomChampNombre, readOnlyPourcentage) {
    ajouterListe = typeof ajouterListe !== 'undefined' ? ajouterListe : true;
    precisionChampAire = typeof precisionChampAire !== 'undefined' ? precisionChampAire : 1;
    precisionChampPourcentage = typeof precisionChampPourcentage !== 'undefined' ? precisionChampPourcentage : 1;

    var champAire = $('#' + nomSousBloc).find('[name="' + nomChampAire + '"]');
    var champPourcentage = $('#' + nomSousBloc).find('[name="' + nomChampPourcentage + '"]');

    function updater(inputChanged, estRefreshInitial) {
        estRefreshInitial = typeof estRefreshInitial !== 'undefined' ? estRefreshInitial : false;
        var aireTotale = 0;

        var estTerrain = false;
        var blocTotal = $('#b07-dimension-base');
        if (blocTotal.length === 0) {
            estTerrain = true;
            blocTotal = $('#b04-terrain-general');
        }

        for (var i = 0; i < champsAireTotale.length; i++) {
            var champ = blocTotal.find('[name="' + champsAireTotale[i] + '"]');
            if (champ.length > 0)
                aireTotale += TryParseFloat(champ.val(), 0);
        }

        var ligne = inputChanged.closest('.sous-bloc-form');
        if (ligne.hasClass('nouvelle-ligne')) {
            return;
        }
        var champAire = ligne.find('[name="' + nomChampAire + '"]');
        var champPourcentage = ligne.find('[name="' + nomChampPourcentage + '"]');

        if (aireTotale === 0) {
            champPourcentage.prop('readonly', false);
            return;
        }

        var nomChampAChanger = (inputChanged.attr('name') === nomChampPourcentage ? nomChampAire : nomChampPourcentage);


        var declencheurEstAireTotale = champsAireTotale.indexOf(inputChanged.attr('name')) !== -1;
        if (declencheurEstAireTotale || estRefreshInitial) {
            if (champAire.length > 0 && champAire.val() !== '' &&
                champAire.val() !== null && champAire.val() !== undefined && aireTotale > 0) {
                var aire = TryParseFloat(champAire.val(), 0);
                var nombre = 1;
                if (typeof nomChampNombre !== 'undefined') {
                    nombre = TryParseInt(ligne.find('[name="' + nomChampNombre + '"]').val(), 1);
                }
                var pourcentage = round(aire * nombre * 100.0 / aireTotale, precisionChampPourcentage);
                if (!isNaN(pourcentage)) {
                    champPourcentage.val(pourcentage);
                    if (!estRefreshInitial) {
                        appliquerChangement(champPourcentage);
                    }
                }
            }
            return;
        }


        var champNombre;
        var nombre;
        if (typeof nomChampNombre !== 'undefined') {
            champNombre = ligne.find('[name="' + nomChampNombre + '"]');
            nombre = TryParseInt(champNombre.val(), 1);
        } else {
            champNombre = null;
            nombre = 1;
        }

        var aire = TryParseFloat(champAire.val(), 0);
        var pourcentage = TryParseFloat(champPourcentage.val(), 0);

        if (!estTerrain) {
            const champNombreRempli = champNombre !== null && champNombre.val() !== '';
            // On update seulement le pourcentage si l'aire n'est pas vide (donc lorsqu'on modifie le champ aire)
            if (nomChampAChanger === nomChampPourcentage && ((champNombreRempli && champAire.val() !== '') || champAire.val() !== ''))
            {
                pourcentage = round(aire * nombre * 100.0 / aireTotale, precisionChampPourcentage);
                champPourcentage.val(pourcentage);
                appliquerChangement(champPourcentage);
            }
            // Puisque de base, l'aire est vide, elle sera initialement calculée à partir du pourcentage
            else if (nomChampAChanger === nomChampAire && champPourcentage.val() !== '') {
                aire = round(pourcentage / nombre * aireTotale / 100.0, precisionChampAire);
                champAire.val(aire);
                appliquerChangement(champAire);
            }

            if (champNombre !== null && champNombre.val() === '' && champAire.val() === '' || typeof nomChampNombre == 'undefined') {
                champPourcentage.prop('readonly', false);
            } else {
                champPourcentage.prop('readonly', true);
            }
        } else {
            if (nomChampAChanger === nomChampAire) {
                aire = round(pourcentage / nombre * aireTotale / 100.0, precisionChampAire);
                champAire.val(aire);
                appliquerChangement(champAire)
            }
            else {
                pourcentage = round(aire * nombre * 100.0 / aireTotale, precisionChampPourcentage);
                champPourcentage.val(pourcentage);
                appliquerChangement(champPourcentage);
            }
        }
    }

    var fonctionUpdate = function () {
        updater($(this));
    };

    champAire.each(function () {
        if ($(this).data('aire_update') != null) {
            $(this).off('change', $(this).data('aire_update'));
        }
    });

    champAire.change(fonctionUpdate);
    champAire.data('aire_update', fonctionUpdate);

    champPourcentage.each(function () {
        if ($(this).data('pourcentage_update') != null) {
            $(this).off('change', $(this).data('pourcentage_update'));
        }
    });

    champPourcentage.change(fonctionUpdate);
    champPourcentage.data('pourcentage_update', fonctionUpdate);

    // refresher les champs pourcentage et aire une première fois
    if (nomSousBloc == 'b04-topographie') {
        champPourcentage.each(function () {
            updater($(this));
        });
    } else {
        // Refresh pourcentage
        champAire.each(function () {
            updater($(this), true);
        });
        champPourcentage.each(function() {
        var ligne = $(this).closest('.sous-bloc-form');
        var aire = ligne.find('[name="' + nomChampAire + '"]').val();

        if (aire !== '' && aire !== null && aire !== undefined) {
            $(this).prop('readonly', true);
        } else {
            $(this).prop('readonly', false);
        }
    });
    }

    if (typeof nomChampNombre !== 'undefined') {
        var champNombre = $('#' + nomSousBloc).find('[name="' + nomChampNombre + '"]');
        champNombre.each(function () {
            if ($(this).data('aire_update') != null) {
                $(this).off('change', $(this).data('aire_update'));
            }
        });

        champNombre.change(fonctionUpdate);
        champNombre.data('aire_update', fonctionUpdate);
    }

    function fonctionUpdateTotalCallback(champTotal){
        var liste = champTotal.data('aire_liste');
        if(typeof liste == 'undefined'){return;}
        $.each(liste, function (index, value) {
            var aireTotale = 0;

            var blocTotal = $('#b07-dimension-base');
            if (blocTotal.length === 0) {
                blocTotal = $('#b04-terrain-general');
            }

            for (var i = 0; i < value.champsAireTotale.length; i++) {
                var champ = blocTotal.find('[name="' + value.champsAireTotale[i] + '"]');
                if (champ.length > 0)
                    aireTotale += TryParseFloat(champ.val(), 0);
            }

            var $sousBloc = $('#' + value.nomSousBloc);
            $sousBloc.find('.sous-bloc-form').each(function () {
                var ligne = $(this);
                var champAire = ligne.find('[name="' + value.nomChampAire + '"]');
                var champPourcentage = ligne.find('[name="' + value.nomChampPourcentage + '"]');

                if (champAire.length > 0 && champAire.val() !== '' &&
                    champAire.val() !== null && champAire.val() !== undefined && aireTotale > 0){
                    var aire = TryParseFloat(champAire.val(), 0);
                    var nombre = 1;
                    if (typeof value.nomChampNombre !== 'undefined') {
                        nombre = TryParseInt(
                            ligne.find('[name="' + value.nomChampNombre + '"]').val(), 1
                        );
                    }
                    var pourcentage = round(
                        aire * nombre * 100.0 / aireTotale,
                        value.precisionChampPourcentage
                    );
                    if (!isNaN(pourcentage)) {
                        champPourcentage.val(pourcentage);
                        appliquerChangement(champPourcentage);
                    }
                }
            });

        });
    }

    var fonctionUpdateTotal = function () {
        var champTotal = $(this);

        fenetreModal.modalMessage({
            titre: "Des champs de la fiche seront ajustés en conséquence. Voulez-vous vraiment modifier ce champ ?",
            texteExplicatif: "",
            conteneur: "#editeur-modal-container",
            taille: "grande",
            boutons: {
                "Oui": {
                    label: " Oui ",
                    id: "",
                    class: "btn btn-success",
                    action: function(){
                        fonctionUpdateTotalCallback(champTotal);
                        let champ_origine = champTotal.data('champ_lier_aire_pourcentage_origine');
                        if(champ_origine) {
                            champ_origine.data('val', champ_origine.val());
                            champ_origine.data('champ_lier_aire_pourcentage_origine', false);
                        }
                    }
                },
                "Non": {
                    label: " Non ",
                    id: "",
                    class: "btn",
                    action: function () {
                        champTotal.val(champTotal.data('val'));
                        let champ_origine = champTotal.data('champ_lier_aire_pourcentage_origine');
                        if(champ_origine) {
                            champ_origine.val(champ_origine.data('val'));
                            champ_origine.data('champ_lier_aire_pourcentage_origine', false);
                            appliquerChangement(champ_origine);
                        }
                        appliquerChangement(champTotal);
                    }
                }
            }

        });
    };

    for (var i = 0; i < champsAireTotale.length; i++) {
        var champ = $('#b07-dimension-base').find('[name="' + champsAireTotale[i] + '"]');

        champ.data('val', champ.val());
        champ.off('focusin').on('focusin', function () {
            $(this).data('val', $(this).val());
        });

        if (ajouterListe) {
            var liste = champ.data('aire_liste');
            if (liste == null) {
                liste = [];
            }

            liste.push({
                nomSousBloc: nomSousBloc,
                nomChampAire: nomChampAire,
                nomChampPourcentage: nomChampPourcentage,
                champsAireTotale: champsAireTotale,
                precisionChampAire: precisionChampAire,
                precisionChampPourcentage: precisionChampPourcentage,
                nomChampNombre: nomChampNombre,
                readOnlyPourcentage: readOnlyPourcentage
            });
            champ.data('aire_liste', liste);
        }

        var fct_update = champ.data('aire_totale_update');
        if (fct_update != null) {
            champ.off('change', fct_update);
        }

        champ.change(fonctionUpdateTotal);
        fonctionUpdateTotalCallback(champ);
        champ.data('aire_totale_update', fonctionUpdateTotal);
    }
}

function initEquipementsEspaces() {
    var dateEvenement = $('#date-evenement').val();
    var idBatiment = $('#current-id-batiment').val();

    var params = {
        'id_batiment': idBatiment,
        'date_evenement': dateEvenement
    };

    $.ajax({
        type: 'GET',
        url: '/gestion-roles/editeur-fiche/get-espace-b81/',
        data: params,
        dataType: 'json',
        success: function (response) {
            var choix = response.liste_resultats;

            var inputEspace = $('.sous-bloc-form').find('[name="b81EspaceLocatifNonresidentiel"]');
            inputEspace.each(function () {
                var currentValue = $(this).val();

                $(this).empty();

                $(this).append($('<option>', {
                    value: '',
                    text: ''
                }));

                for (var i = 0; i < choix.length; i++) {
                    $(this).append($('<option>', {
                        value: choix[i].id,
                        text: choix[i].texte
                    }));
                }

                var option = $(this).find("option[value='" + currentValue + "']");
                if (option.length > 0) {
                    $(this).val(currentValue);
                    $(this).attr('title', option.text());
                }
                else {
                    $(this).val('');
                    $(this).attr('title', '');
                }
            });
        }
    });
}

// avant le save, cocher une photo / croquis pour blocs 05 / 06 comme étant principal s'il n'y a qu'un seul document
function cocherImagePrincipale() {
    $('[id^="b05-document"], [id^="b06-document"]').each(function () {
        var lignes = $(this).find('.sous-bloc-form').not(`.${CLASSE_NOUVELLE_LIGNE},[methode="DELETE"]`);
        if (lignes.length === 1) {
            var inputPrincipal = lignes.find('[name="bool_principale"]');
            if (!inputPrincipal.prop("checked")) {
                inputPrincipal.trigger('click');
            }
        }
    });
}

// fonction servant à changer des valeurs de champ lorsqu'on clique sauvegarder, juste avant que le call save ajax soit appelé
// sert entre autres à setter des valeurs par défaut
function changerValeursAvantSauvegarde() {
    cocherImagePrincipale();

    var idFormulaire = $('#current-id-formulaire').val();
    if ($.inArray(idFormulaire, [ID_FORMULAIRE.residentiel, ID_FORMULAIRE.nonResidentiel]) != -1) {

        var b08 = $('#b08-renseignements-generaux-batiment');
        var b08CodeUtilisation = b08.find('[name="codeUtilisation"]');
        var codeUtilisation1990 = getCodeUtilisation1990(idFormulaire).responseJSON;
        if ($.inArray(b08CodeUtilisation.val(), codeUtilisation1990) == -1) {

            var nb_chambre_locative = b08.find('[name="nb_chambre_locative"]');
            if (nb_chambre_locative.val() == "") {
                nb_chambre_locative.val('0').change();
            }

            var nb_local = b08.find('[name="nb_local"]');
            if (nb_local.val() == "") {
                nb_local.val('0').change();
            }

            var pourcentage_plafond_cathedrale = $('#b33-finition-interieure').find('[name="pourcentage_plafond_cathedrale"]');
            if (pourcentage_plafond_cathedrale.val() == "") {
                pourcentage_plafond_cathedrale.val('0').change();
            }

            var b46PresenceElectricite = $('#b46-electricite').find('[name="presenceElectricite"]');
            if (b46PresenceElectricite.val() != '9') {
                var pcClimatisation = $('#b44-chauffage-ventilation-climatisation').find('[name="pourcentage_climatisation"]');
                if (pcClimatisation.val() == "") {
                    pcClimatisation.val('0').change();
                }
            }

            pourcentage_plafond_cathedrale = $('#b32-fini-plafond').find('[name="pourcentage_plafond_cathedrale"]');
            if (pourcentage_plafond_cathedrale.val() == "") {
                pourcentage_plafond_cathedrale.val('0').change();
            }
        }
    }

    var b81Inventaire = $('#b81-inventaire');
    if (b81Inventaire.length) {
        var b81DateReference = b81Inventaire.find('[name="date_reference"]');
        var b81Residentiel = $('#b81-espace-locatif-residentiel').find('.sous-bloc-form:not(.nouvelle-ligne)').filter(filtrerLigneSuppression);
        var b81NonResidentiel = $('#b81-espace-locatif-nonresidentiel').find('.sous-bloc-form:not(.nouvelle-ligne)').filter(filtrerLigneSuppression);
        var montantAnnuelModifie = b81Inventaire.find('[name="mnt_autre_revenu"].valeur-modifiee');
        if (b81Residentiel.length || b81NonResidentiel.length || montantAnnuelModifie.length) {
            if (b81DateReference.val() == '') {
                b81DateReference.val($('#date-evenement').val().substring(0, 10));
            }
        } else {
            b81DateReference.val('');
        }
    }
}

function chargerBloc(idBloc, callback) {
    var dateEvenement = $('#date-evenement').val();
    var idEvenement = $('#id-evenement').val();
    var idBatiment = $('#current-id-batiment').val();
    var idFormulaire = $('#current-id-formulaire').val();
    var idTypeBatiment = $('#current-id-type-batiment').val();

    ouvrirFicheTaj(idBatiment, idTypeBatiment, idEvenement, dateEvenement, idFormulaire, idBloc, callback);
}

function supprimerBatiment() {
    if (estModeDeconnecte()) return;
    var idBatiment = $('#current-id-batiment').val();
    var idEvenement = $('#id-evenement').val();

    fenetreModal.modalMessage({
        titre: '<p></p><h5 class="modal-title text-center red">Les données seront détruites de façon permanente</h5><p></p>',
        texteExplicatif: "",
        enteteTitre: "Souhaitez-vous vraiment supprimer ce bâtiment ?",
        conteneur: "#editeur-modal-container",
        sansX: true,
        taille: "grande",
        boutons: {
            "Oui": {
                label: " Oui ",
                type: "delete",
                id: "",
                class: "btn btn-success",
                classSupp: "btn-danger",
                action: function () {
                    wait.start();
                    var noBatimentSupprime = $('#current-no-batiment').val();

                    var jqxhr = $.ajax({
                            type: "POST",
                            url: '/' + NOM_MODULE + '/editeur-fiche/supprimer-batiment/' + idEvenement + '/' + idBatiment +'/'
                        }
                    );

                    jqxhr
                        .done(function (response) {
                            $('#blocs-container').empty();

                            infos.ajouterMessageToast({
                                message: "Suppression du bâtiment " + noBatimentSupprime + " réussie",
                                messageDuree: 1500,
                                icone: 'fa-check-circle-o',
                                iconeCouleur: 'green'
                            });

                            $('#current-id-formulaire').val('None');
                            $('#current-id-batiment').val('est_supprime');
                            var idEvenement = $('#id-evenement').val();
                            ouvrirUrlEvenement(idEvenement);
                        });

                    jqxhr
                        .fail(function (xhr, textStatus, errorThrown) {
                            wait.stop();
                            infos.ajouterMessageToast({
                                message: "Erreur de suppression du bâtiment",
                                messageDuree: 1500,
                                messageCouleur: "red"
                            });
                        });
                }
            },
            "Non": {
                label: " Non ",
                id: "",
                class: "btn",
                action: function () {
                }
            }
        }
    });
}


function desannulerBatiment() {
    var idBatiment = $('#current-id-batiment').val();
    var idEvenement = $('#id-evenement').val();
    var idUe = $('#id-ue').val();

    fenetreModal.modalMessage({
        titre: '<p></p><h5 class="modal-title text-center red">Le bâtiment va redevenir actif</h5><p></p>',
        texteExplicatif: "",
        enteteTitre: "Souhaitez-vous vraiment désannuler ce bâtiment ?",
        conteneur: "#editeur-modal-container",
        sansX: true,
        taille: "grande",
        boutons: {
            "Oui": {
                label: " Oui ",
                id: "",
                class: "btn btn-success",
                action: function () {
                    wait.start();
                    var noBatimentSupprime = $('#current-no-batiment').val();

                    var params = {
                        id_evenement: idEvenement,
                        id_batiment: idBatiment,
                        id_ue: idUe
                    };

                    var jqxhr = $.ajax({
                            type: "GET",
                            url: "/" + NOM_MODULE + "/editeur-fiche/desannuler-batiment/",
                            dataType: 'json',
                            data: params
                        }
                    );

                    jqxhr
                        .done(function (response) {
                            $('#blocs-container').empty();

                            infos.ajouterMessageToast({
                                message: "Désannulation du bâtiment " + noBatimentSupprime + " réussie",
                                messageDuree: 1500,
                                icone: 'fa-check-circle-o',
                                iconeCouleur: 'green'
                            });

                            var idEvenement = $('#id-evenement').val();
                            ouvrirUrlEvenement(idEvenement);
                        });

                    jqxhr
                        .fail(function (xhr, textStatus, errorThrown) {
                            wait.stop();
                            infos.ajouterMessageToast({
                                message: "Erreur de désannulation du bâtiment",
                                messageDuree: 1500,
                                messageCouleur: "red"
                            });
                        });
                }
            },
            "Non": {
                label: " Non ",
                id: "",
                class: "btn",
                action: function () {
                }
            }
        }
    });
}

function nombreValidation(type) {
    var nombre = 0;
    $.each(tree_data['validations']['additionalParameters']['children'][type]['additionalParameters']['children'], function (index, children) {
        nombre += Object.keys(children['additionalParameters']['children']).length;
    });
    return nombre;
}

function filtrerLigneSuppression() {
    return $(this).find('[class*="suppression-ligne"]').length == 0;
}

function changerTypeFiche() {
    if (estModeDeconnecte()) return;
    fenetreModal.modalMessage({
        titre: "Voulez-vous vraiment changer le type de bâtiment de cette fiche ?",
        texteExplicatif: "Ceci aura pour effet d'annuler la fiche de bâtiment en cours. Il sera toujours possible de consulter cette fiche en lecture seule.",
        conteneur: "#editeur-modal-container",
        taille: "grande",
        boutons: {
            "Oui": {
                label: " Oui ",
                id: "",
                class: "btn btn-success",
                action: function () {
                    $('#modal-changer-type-fiche').modal('show');
                }
            },
            "Non": {
                label: " Non ",
                id: "",
                class: "btn",
                action: function () {
                    fenetreModal.fermerModalAlerteDivs();
                }
            }
        }
    });
}

function boutonOuvrirEvenement() {
    if (estModeDeconnecte()) return;
    var idEvenement = $('#editeur-fiche-globales-variables #id-evenement').val();
    tenueAJourModal.ouvrirWizardEvenement(idEvenement);
}

function boutonCreerActualisationInventaire () {
    if (estModeDeconnecte()) return;
    var idEvenement = $('#editeur-fiche-globales-variables #id-evenement').val();
    tenueAJourModal.ouvrirModalCreationActualisationInventaire(idEvenement);
}

function editerFicheEvenementCourant() {
    if (estModeDeconnecte()) return;
    fenetreModal.modalMessage({
        titre: "Voulez-vous vraiment éditer toutes les fiches de l'évènement courant ?",
        texteExplicatif: "Ceci aura pour effet de rendre éditable les fiches de l'évènement en cours et de mettre en lecture seule les fiches des autres évènements ouverts éditables.",
        conteneur: "#editeur-modal-container",
        taille: "grande",
        boutons: {
            "Oui": {
                label: " Oui ",
                id: "",
                class: "btn btn-success",
                action: function () {
                    var idEvenement = $('#id-evenement').val();

                    wait.start();

                    let url = `/${NOM_MODULE}/editeur-fiche/${idEvenement}/editer-fiche-evenement-courant/`
                    let success_cb = function (resp) {
                        if ($('#current-id-batiment').val() === 'None'){
                            location.reload()
                        } else {
                            ouvrirUrlEvenement(idEvenement);
                        }
                    }
                    call_ajax(url, "GET", null, success_cb)
                }
            },
            "Non": {
                label: " Non ",
                id: "",
                class: "btn",
                action: function () {
                    fenetreModal.fermerModalAlerteDivs();
                }
            }
        }
    });
}

function getCodeUtilisation1990(id_formulaire) {
    return $.ajax({
        type: 'GET',
        dataType: 'json',
        async: false,
        url: "/" + NOM_MODULE + "/editeur-fiche/code-utilisation-1990/" + id_formulaire
    });
}


// #23009
const Keyboard = {
    selectedElement: "",
    elements: {
        main: null,
        keysContainer: null,
        keys: []
    },
    keyboard_type: "numeric",
    eventHandlers: {
        oninput: null,
        onclose: null
    },

    properties: {
        value: "",
        capsLock: false
    },
    modeDebug: true,
    opened: false,
    initialised: false,
    active: true, // #23465

    init() {
        Keyboard.modeDebugLog('Keyboard init...');
        Keyboard.elements.main = document.createElement("div");
        Keyboard.elements.keysContainer = document.createElement("div");
        Keyboard.elements.main.classList.add("keyboard", "keyboard--hidden");
        Keyboard.elements.main.setAttribute('id', 'keyboard');

        // bouton icone dans le header pour désactiver  le clavier
        var htmlToggleKeyboardHead = '<button type="button"><i class="ace-icon fa fa-chevron-circle-down fa-lg"></i></button>';
        Keyboard.elements.iconeToggleHead = document.createElement("div");
        Keyboard.elements.iconeToggleHead.id = "keyboard-icone-toggle-head";
        Keyboard.elements.iconeToggleHead.innerHTML = htmlToggleKeyboardHead;

        // bouton icone pour réactiver le clavier, collé au bas de l'écran
        var htmlToggleKeyboardFoot = '<button type="button"><i class="ace-icon fa fa-chevron-circle-up fa-lg"></i><i class="keyboard-icone-toggle-foot-icone-keyboard ace-icon fa fa-keyboard-o fa-lg"></i></button>';
        Keyboard.elements.iconeToggleFoot = document.createElement("div");
        Keyboard.elements.iconeToggleFoot.id = "keyboard-icone-toggle-foot";
        Keyboard.elements.iconeToggleFoot.classList.add('hide');
        Keyboard.elements.iconeToggleFoot.innerHTML = htmlToggleKeyboardFoot;
        document.querySelector('body').appendChild(Keyboard.elements.iconeToggleFoot);

        Keyboard.elements.keysContainer.classList.add("keyboard_keys");
        Keyboard.elements.keys = Keyboard.elements.keysContainer.querySelectorAll(".keyboard_key");
        Keyboard.elements.main.appendChild(Keyboard.elements.iconeToggleHead);
        Keyboard.elements.main.appendChild(Keyboard.elements.keysContainer);
        document.querySelector('body').appendChild(Keyboard.elements.main);

        Keyboard.desactiverInputmodeChampsFiche();

        document.addEventListener('click',function(event){
            if(!Keyboard.active){
                return;
            }
            if(event.target.classList.contains('integer-spinner') || event.target.classList.contains('pourcentage-spinner') || event.target.classList.contains('annee-spinner')){
                Keyboard._setupKeyboard("integer");
                Keyboard.selectedElement = event.target;
                Keyboard.open(event.target.value, currentValue => {
                    event.target.value = currentValue;
                });
            }else if(event.target.classList.contains('champ-decimal')){
                Keyboard._setupKeyboard("numeric");
                Keyboard.selectedElement = event.target;
                Keyboard.open(event.target.value, currentValue => {
                    event.target.value = currentValue;
                });
            }
            // Pour la fermeture en click exterieur
            else if(Keyboard.opened){
                const box = document.getElementById('keyboard');
                if (!box.contains(event.target)) {
                    Keyboard.close();
                }
            }

        }, true);
        Keyboard.elements.iconeToggleHead.addEventListener("click", () => {
            Keyboard.deactivate();
        });
        Keyboard.elements.iconeToggleFoot.addEventListener("click", () => {
            Keyboard.reactivate();
        });

        var evb_preferenceKeyboardDeactivated = localStorage.getItem("evb_preferenceKeyboardDeactivated");
        if(evb_preferenceKeyboardDeactivated=="true"){
            Keyboard.active = false;
            Keyboard.elements.iconeToggleFoot.classList.remove('hide');
        }

        Keyboard.initialised = true;
    },
    desactiverInputmodeChampsFiche() {
        var selecteurClassesChampsADesactiver = ['champ-decimal', 'integer-spinner', 'pourcentage-spinner', 'annee-spinner'];
        var blocsContainer = document.getElementById('blocs-container');
        $(selecteurClassesChampsADesactiver).each(function(i, classe){
            for (const champ of blocsContainer.getElementsByClassName(classe)) {
                champ.setAttribute('inputmode', 'none');
            }
        });
    },
    _setupKeyboard(type) {
        Keyboard.elements.keysContainer.innerHTML = "";
        Keyboard.elements.keysContainer.appendChild(Keyboard._createKeys(type));
    },
    _createKeys(keyboard_type) {
        const fragment = document.createDocumentFragment();
        var keyLayout = [];
        if(keyboard_type == "integer"){
            keyLayout = [
                "7", "8", "9", "br", "4", "5", "6", "br", "1", "2", "3", "br", "empty", "0", "backspace","done"
                ];
        }else if(keyboard_type == "numeric"){
            keyLayout = [
                "7", "8", "9", "br", "4", "5", "6", "br", "1", "2", "3", "br", ".", "0", "backspace","done"
                ];
        }


        // Creates HTML for an icon
        const createIconHTML = (icon_name) => {
            return '<span class="keyboard-icons ace-icon fa fa-'+ icon_name + ' xbigger-130"></span>';
        };

        keyLayout.forEach(key => {
            const keyElement = document.createElement("button");
            const insertLineBreak = ["backspace", "br"].indexOf(key) !== -1;

            // Add attributes/classes
            keyElement.setAttribute("type", "button");
            keyElement.classList.add("keyboard_key");

            switch (key) {
                case "backspace":
                    keyElement.classList.add("backspace-btn");
                    keyElement.innerHTML = createIconHTML("eraser");

                    keyElement.addEventListener("click", () => {
                        this.properties.value = this.properties.value.substring(0, this.properties.value.length - 1);
                        this._triggerEvent("oninput");
                        this._fireKeyEvent();
                    });

                    break;

                case "done":
                    keyElement.classList.add("keyboard_key--wide", "keyboard_key--dark");
                    keyElement.innerHTML = createIconHTML("check-circle");

                    keyElement.addEventListener("click", () => {
                        this.close();
                        this._triggerEvent("onclose");
                    });

                    break;

                case "br":
                    keyElement.classList.add("hidden");
                    break;

                case "empty":
                    keyElement.classList.add("invisible");
                    break;

                default:
                    keyElement.textContent = key.toLowerCase();
                    keyElement.addEventListener("click", () => {
                        this.properties.value += this.properties.capsLock ? key.toUpperCase() : key.toLowerCase();
                        this._triggerEvent("oninput");

                        // Propagate Keyboard event
                        this._fireKeyEvent();

                    });

                    break;
            }

            fragment.appendChild(keyElement);

            if (insertLineBreak) {
                fragment.appendChild(document.createElement("br"));
            }
        });


        return fragment;
    },

    _fireKeyEvent(){
        var evt = new KeyboardEvent("input", {
            bubbles: true,
            cancelable: true,
            view: window
        });
        Keyboard.selectedElement.dispatchEvent(evt);
        var event_change = new CustomEvent('change', { bubbles: true });
        Keyboard.selectedElement.dispatchEvent(event_change);
    },

    _triggerEvent(handlerName) {
        if (typeof this.eventHandlers[handlerName] == "function") {
            this.eventHandlers[handlerName](this.properties.value);
        }
    },

    open(initialValue, oninput, onclose) {
        this.properties.value = initialValue || "";
        this.eventHandlers.oninput = oninput;
        this.eventHandlers.onclose = onclose;
        this.elements.main.classList.remove("keyboard--hidden");
        this.opened = true;
    },

    close() {
        this.properties.value = "";
        this.eventHandlers.oninput = oninput;
        this.eventHandlers.onclose = onclose;
        this.elements.main.classList.add("keyboard--hidden");
        this.opened = false;
    },
    deactivate(){
        localStorage.setItem("evb_preferenceKeyboardDeactivated", "true");
        Keyboard.close();
        Keyboard.elements.iconeToggleFoot.classList.remove('hide');
        this.active=false;
    },
    reactivate(){
        localStorage.removeItem("evb_preferenceKeyboardDeactivated");
        this.active=true;
        Keyboard.open();
        Keyboard.elements.iconeToggleFoot.classList.add('hide');
    },
    modeDebugLog(message){
        if(Keyboard.modeDebug){
            console.log(message);
        }
    }
};

function ajouterEditerLigneImputerTemps(element) {
    var row = $(element).closest('.sous-bloc-form');
    var date = $(row).find('[name="date_attestation"]').val();
    var date_initial = $(row).find('[name="date_attestation"]').data('initial-value');

    var imputer_temps_section = $('#b79-imputer-temps-sous-bloc');
    var lignes_imputer_temps = $(imputer_temps_section).find('.sous-bloc-form:not(.nouvelle-ligne)');

    var ligne_initial = $(lignes_imputer_temps).filter(function() {
        return $(this).find('[name="date_attestation"]').val() === date_initial;
    })
    var nb_ligne_b79_avec_date;
    if (!$(lignes_imputer_temps).find('[name="date_attestation"]').filter(function(){
        return this.value === date}).length) {
        //lorsqu'on change une date attestation et que la ligne imputer n'existe pas
        var nouvelle_ligne = $(imputer_temps_section).find('.nouvelle-ligne');
        nb_ligne_b79_avec_date = $(row).siblings(':not(.nouvelle-ligne):not([methode="DELETE"])').filter(function() {
            return $(this).find('[name="date_attestation"]').val() === date_initial;
        }).length
        if (ligne_initial && nb_ligne_b79_avec_date === 0) {
            $(nouvelle_ligne).find('[name="temps_impute_inspection_minute"]').val($(ligne_initial).find('[name="temps_impute_inspection_minute"]').val()).trigger('change')
            $(nouvelle_ligne).find('[name="temps_impute_deplacement_minute"]').val($(ligne_initial).find('[name="temps_impute_deplacement_minute"]').val()).trigger('change')
            $(nouvelle_ligne).find('[name="notes"]').val($(ligne_initial).find('[name="notes"]').val()).trigger('change')
        }
        $(nouvelle_ligne).find('[name="date_attestation"]').val(date).trigger('change')
    }
    else {
        //lorsqu'on change une date attestation et que la ligne imputer temps existe
        nb_ligne_b79_avec_date = $(row).siblings(':not(.nouvelle-ligne):not([methode="DELETE"])').filter(function() {
            return $(this).find('[name="date_attestation"]').val() === date_initial;
        }).length
        var ligne = $(imputer_temps_section).find('.sous-bloc-form').filter(function() {
            return $(this).find('[name="date_attestation"]').val() === date;
        });
        if (ligne_initial.length && nb_ligne_b79_avec_date === 0) {
            $(ligne).find('[name="temps_impute_inspection_minute"]').val($(ligne_initial).find('[name="temps_impute_inspection_minute"]').val()).trigger('change')
            $(ligne).find('[name="temps_impute_deplacement_minute"]').val($(ligne_initial).find('[name="temps_impute_deplacement_minute"]').val()).trigger('change')
            $(ligne).find('[name="notes"]').val($(ligne_initial).find('[name="notes"]').val()).trigger('change')
        }
    }
}
function synchroniserImputerTempsAttestations() {
    var imputer_temps_section = $('#b79-imputer-temps-sous-bloc')
    var lignes_attestations = $('#b79-attestation-sous-bloc .sous-bloc-form:not(.nouvelle-ligne):not([methode="DELETE"])')
    $(imputer_temps_section).find('.sous-bloc-form:not(.nouvelle-ligne) [name="date_attestation"]').each(function() {
        var date = $(this).val();
        var row = $(this).closest('.sous-bloc-form');

        if ($(lignes_attestations).find('[name="date_attestation"]').filter(function(){
            return this.value === date}).length) {
            return
        }
        if ($(row).attr('id-model-instance') === 'None') {
           $(row).remove();
        } else {
            if (!$(row).find('.ctrl-suppression').is(':checked')){
                $(row).find('.ctrl-suppression').click()
            }
        }
    })
}

function retirerLigneImputerTemps(ctrl) {
    var row = $(ctrl).closest('.sous-bloc-form')
    var date_attestation = $(row).find('[name="date_attestation"]').val()
    var nb_b79_rows_meme_date = $(row).siblings(':not(.nouvelle-ligne):not([methode="DELETE"])').filter(function() {
        return $(this).find('[name="date_attestation"]').val() == date_attestation;
    }).length
    var row_imputer_temps = $('#b79-imputer-temps-sous-bloc').find('.sous-bloc-form:not(.nouvelle-ligne)').filter(function() {
        return $(this).find('[name="date_attestation"]').val() == date_attestation;
    });
    if (nb_b79_rows_meme_date === 0) {
        if ($(row_imputer_temps).attr('id-model-instance') === 'None') {
            if ($(ctrl).is(':checked')) {
               $(row_imputer_temps).remove()
            }
        } else {
            $(row_imputer_temps).find('.ctrl-suppression').click()
        }
    }
}

function chargerBlocPropagation(idBloc) {
    let accordeon = $('form[id_bloc="' + idBloc + '"]').closest('[id^=propagation-].panel-collapse');
    chargerContenuBlocPropagation(accordeon);
}

function chargerContenuBlocPropagation(accordeon) {
    let divPanelBody = accordeon.find('.panel-body');
    let divBatiment = accordeon.closest('[id^=accordion-batiment-]');
    let splitId = divBatiment.attr('id').split('-');
    let idBatiment = splitId[2];
    let idFormulaire = splitId[4];

    let idAccordionSplit = accordeon.attr('id').split('-');
    let idEvenementAnt = idAccordionSplit[1];
    let idEvenementPropagation = idAccordionSplit[2];
    let idBloc = idAccordionSplit[3];

    let parametres = {
        id_ue: $('#wizard').attr('id-ue'),
        id_evenement_ant: idEvenementAnt,
        id_evenement_propagation: idEvenementPropagation,
        id_batiment: idBatiment,
        id_formulaire: idFormulaire,
        id_bloc: idBloc,
        id_bloc_affiche: idBloc
    };
    wait.start('contenu');

    $.ajax({
        type: "GET",
        url: "/gestion-roles/tenue-a-jour/propagation-contenu/",
        data: parametres,
        dataType: 'html',
        success: function (response) {
            divPanelBody.html(response);
            initBlocsCharges(idFormulaire, idBloc);
            fenetreModal.calculerHauteurModal($('#modal-wizard-evenement'));
            wait.stop('contenu');
        },
        error: function (xhr, ajaxOptions, thrownError) {
            infos.ajouterMessageToast({
                message: 'Une erreur s\'est produite. Contactez un administrateur.',
                messageDuree: 0
            });
            wait.stop('contenu');
        }
    });
}
function scrollToElement(elementId) {
    console.log('Attempting to scroll to element:', elementId);
    const element = document.getElementById(elementId);
    if (!element) {
        console.error('Element not found:', elementId);
        return;
    }

    if (window.isRunningInApp) {
        console.log('Using scrollIntoView with offset...');

        // Calculer l'offset total : toolbar + entête + liens blocs
        const toolbar = document.querySelector('ion-header ion-toolbar');
        const toolbarHeight = toolbar ? toolbar.offsetHeight : 0;

        const enteteHeight = $('#entete-fixe').outerHeight() || 0;
        const liensHeight = $('#liens-blocs').outerHeight() || 0;

        const totalOffset = toolbarHeight + enteteHeight + liensHeight + 45;
        console.log('Toolbar height:', toolbarHeight);
        console.log('Entete height:', enteteHeight);
        console.log('Liens height:', liensHeight);
        console.log('Total offset applied:', totalOffset);

        // Créer temporairement un padding-top pour simuler l'offset
        const originalPaddingTop = element.style.paddingTop;
        element.style.paddingTop = totalOffset + 'px';

        // Scroller vers l'élément avec le padding
        element.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest'
        });

        // Restaurer le padding après le scroll
        setTimeout(() => {
            element.style.paddingTop = originalPaddingTop;
            console.log('Padding restored');
        }, 1000);

    } else {
        // Mode web
        let offset = $('#liens-blocs').outerHeight() + $('#entete-fixe').outerHeight();
        $(document).scrollTop($("#" + elementId).offset().top - offset);
    }
}

function gererAffichageQuestionOmiseInscriteTerrain(input, inputAvant, typeTerrain) {
    const nouvelleValeur = input.val()
    let valeurAvant;
    const containerElement = input.closest('.blocForm')
    const natureIndumentOmiseInscriteContainer = containerElement.find('input[name="est_nature_indument_omise_inscrite"]');
    let estNatureIndumentOmiseInscrite = natureIndumentOmiseInscriteContainer.val() || '';

    containerElement.find(' [name="est_indument_omise_inscrite"]').on('change', function () {
        // changer la valeur de est_nature_indument_omise_inscrite selon la valeur du radio bouton
        $(this).closest('.blocForm').find('input[name="est_nature_indument_omise_inscrite"]').val($(this).val());
    });

    if (inputAvant !== undefined) {
        valeurAvant = inputAvant.val();
    }

    let valeurApresVide;

    if (input.is(':not(:radio)')) {
        valeurApresVide = verifierPresenceValeurInput(nouvelleValeur);

    } else {
        const inputSuperficie = input.closest('#' + typeTerrain).find('input#form-superficie_agricole_exploitable_non_exploitee')
        valeurApresVide = verifierPresenceValeurInput(inputSuperficie.val());
    }

    const valeurAvantVide = verifierPresenceValeurInput(valeurAvant);
    let estAffiche = valeurAvantVide !== valeurApresVide;

    if (estAffiche && input.is(':not(:radio)')) {
        estAffiche = valeurAvantVide || valeurApresVide;
    }

    if (!estAffiche && estNatureIndumentOmiseInscrite !== '') {
        containerElement.find('input[name="est_nature_indument_omise_inscrite"]').val('');
    }

    tenueAJourModal.afficherQuestionOmiseInscrite(containerElement, estAffiche, estNatureIndumentOmiseInscrite);

}

function gererTexteQuestionOmiseInscriteTerrain(input, inputAvant, typeTerrain) {
    const nouvelleValeur = input.val();
    const containerElement = input.closest('.blocForm');
    let valeurAvant;

    valeurAvant = inputAvant.val();

    const valeurAvantVide = verifierPresenceValeurInput(valeurAvant);
    let valeurApresVide;

    if (input.is(':not(:radio)')) {
        valeurApresVide = verifierPresenceValeurInput(nouvelleValeur);

    } else {
        const input_superficie = input.closest('#' + typeTerrain).find('input#form-superficie_agricole_exploitable_non_exploitee').val();
        valeurApresVide =verifierPresenceValeurInput(input_superficie);
    }

    let remplacerTexte = true;

    if (!valeurAvantVide && valeurApresVide) {
        remplacerTexte = false;
    }

    tenueAJourModal.initQuestionOmiseInscrite(containerElement, remplacerTexte);
}

function verifierPresenceValeurInput(valeur) {
    return (valeur === '' || valeur === undefined || valeur === '0');
}
